import React, { Component } from 'react'
import {
    GET_IDEA_URL, UPDATE_IDEA_URL, APPROVED, IMPACTOPTIONS, NO_VD, VD_TO_CLIENT,
    VD_TO_GENPACT, VD_TO_CLIENT_PLUS_GENPACT, GET_METADATA, DISPLAYPROJECTTHEME, AI_DOC_LINK, AIFIRST, DELEGATE_IDEA_URL, PENDING,
    SENT_BACK, REJECTED, DATA_BRIDGE_CAMPAIGN, X_POLLINATION_CAMPAIGN, ACCESS_TOKEN, USER_DATA, PROJECT_VIEW, PPT_CONTENT,
    SIGNOFF_CONTENT, REVIEW_IDEA_URL, GOL_APPROVAL_CONTENT, FPnA_APPROVAL_CONTENT, YESORNO,
     IMPACT_TO_GENPACT, IMPACT_TO_CLIENT, PRODUCTIVITYGOLIVEDATE, COMPLETE_STATUS,
    CANCEL,AWAITING_QAULITY_CHECK_REVIEW,AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
} from '../assets/constants/constants';
import Toast from 'light-toast';
import { selectValidation as selectStyle, textBoxValidation } from "../utils/FieldValidation";
import UpdatedSpeech from './UpdatedSpeech';
import Select from 'react-select';
import ValueDelivery from '../utils/ValueDelivery'
import ShowTree from '../utils/ShowTree';
import { Link } from 'react-router-dom'

import Checksum from "../utils/Checksum";

const projectType = [
    {
        value: 0,
        label: "GB"
    },
    {
        value: 1,
        label: "BB"
    },
    {
        value: 2,
        label: "MBB"
    },
]


export class UpdateIdeaPage extends Component {
    sessionData = JSON.parse(localStorage.getItem(USER_DATA));
    accessToken = localStorage.getItem(ACCESS_TOKEN);
    constructor(props) {
        super(props)
        const isApprovalPage = `${this.props.location.approval}`;
        let propsData = this.props.location;
        this.state = {
            onInitPageTime: "",
            ServiceLineSelectedOption: null,
            subServiceLineSelectedOption: null,
            serviceLineList: [],
            subServiceLineList: [],
            methodologyList: [],
            methodologySelectedOptions: null,
            BlackBeltUserId: 111,
            BlackBeltUserName: "",
            BlackBeltUserEmail: "",
            blackBeltSelectedOption: null,
            blackbeltList: [],
            ideaItem: {},
            WorkflowStatus: "",
            approvalPage: isApprovalPage,
            Comment: "",
            accountName: "",
            campaignName: "",
            serviceLineName: "",
            base64File1: "",
            base64File2: "",
            base64File1: "",
            base64File2: "",
            base64File3: "",
            base64File4: "",
            filename1: "",
            filename2: "",
            filename3: "",
            filename4: "",
            fileType1: "",
            fileType2: "",
            fileType3: "",
            fileType4: "",
            selectStyle: selectStyle,

            reviewComments: [],
            propsData: propsData,
            commentLog: false,
            cancelRequest: false,
            Comments: '',
            Role: "Idea Owner",
            speechModal: false,
            modalIndex: "",
            previousTextForSpeech: "",

            businessImpactMasterList: null,

            impactOptionSelected: null,
            showClientFields: false,
            showGOLFields: false,

            
            signOffFilename: "",
            signOffFileType: "",
            signOffContent: "",

            fpnaUpload: false,
            replaceFpnaDoc: false,
            fpnaOhr: "",
            golOhr: "",
            businessImpactValueArray: [],
            summaryArray: [],
            qcCommentLog: false,
            qcComments: [],
            IsVDMonetizable: "",
            MonetizationStatus: "",
            duplicateQCOHR: "",
            qcCommentsWithVD: [],
            qcLastComment: "",
            golFpnaFileDetails: [],
            isFpnaRequired: false,
            displayProjectTheme: false,
            //clustor states starts here
            clusterModal: false,
            projectTypeSelectedOption: null,
            projectIDSelectedOption: null,
            clustorProjects: [],
            guidSelectedOption: null,
            showHirearchy: true,
            showTreeHirearchy: false,
            clusterData: [],
            isClusterSaveDisabled: true,
            displayParentAlpha: '',
            clusterOptionSearched: false,


            // DB variables starts here

            // state variables used for validate of template data
         
            convertIdeaID: "",

            navigatetoDiagnostic: false,
            showHrefModal: false,
          

            campaignList: [],
            campaignInsight: "",

            //AI
            ideasAI: [],
            isIdeaReplicable: "",
            IsSolnFeasibleValue:"",
            POHRCount: 0,

            // productivity
            methodologies: "",
            methodologyList: [],
            contractedUploadedOHRCount: 0,
            nonContractedUploadedOHRCount: 0,
            totalOHRUploaded: 0,

            // code section state variable
            individualCoderOHR: "",
            coderOHRs: [],
            codersLoading: false,
            codersAddButtonDisable: false,

            clientName: "",
            clientRole: "",
            parentProjectName: "",
            toolsMethodologyMandatory: false,


            
        }
    }

    async componentDidMount() {
        await this.fetchIdea();
        await this.fetchMetadata();
    }

    setToolsMethodologies = () => {
        let localMethodology = this.state.ideaItem.MethodologyName && this.state.ideaItem.MethodologyName.replace(/[|,]/g, ",")
        localMethodology = localMethodology.split(",");
        let options = [];
        this.state.methodologyList && this.state.methodologyList.map((item, ind) => {
            if (this.state.ideaItem.TransformationLeverName === item.TransformationLever && item.RecStatus === true && this.state.ideaItem.AIClassification === item.AIClassification) {
                if (this.state.ideaItem.DigitalProjectType) {
                    if (this.state.ideaItem.DigitalProjectType === item.DigitalProjectType) {
                        localMethodology.map((local, index) => {
                            if (local === item.Methodology) {
                                options.push({ value: item.RecID, label: item.Methodology, sortOrder: item.SOrd || 0 })
                            }
                        })
                    }
                }
                else {
                    localMethodology.map((local, index) => {
                        if (local === item.Methodology) {
                            options.push({ value: item.RecID, label: item.Methodology, sortOrder: item.SOrd || 0 })
                        }
                    })
                }
            }
        })
        options.sort((a, b) => a.sortOrder - b.sortOrder);
        this.setState({ methodologySelectedOptions: options }, () => {
            //console.log('methodology selected option => ', this.state.methodologySelectedOptions)
        })
    }

    fetchMetadata = async() => {
        try {
            const param = {
                EntityType: "",
                EntityName: "",
            };
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param),
            };

            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    Toast.hide()
                    this.setState(
                        {
                            workFlowStatusList: data ? data.WorkflowStatus : [],
                            certificationLevelsList: data ? data.CertificationLevels : [],
                            certificationWorkTypeList: data ? data.WorkType : [],
                            transformationLeversList: data ? data.TransformationLevers : [],
                            methodologyList: data ? data.Methodologies : [],
                            businessImpactMasterList: data ? data.BIMasterDataVerseNew : [],
                            biThreshold: data.BIQCThreshold ? data.BIQCThreshold[0] ? data.BIQCThreshold[0].pg_threshold : 0 : 0,
                            vrconditiontype: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_vrconditiontype : [] : [],
                            vrVerticalMapping: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_vertical ? data.BIQCVRMapping[0].pg_vertical.split("|") : "ALL" : "ALL" : "ALL",
                            vrRegionMapping: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_region ? data.BIQCVRMapping[0].pg_region.split("|") : "ALL" : "ALL" : "ALL",
                            
                            campaignList: data ? data.Campaigns : [],
                            serviceLineList: data ? data.ServiceLines : [],
                            subServiceLineList: data ? data.ServiceLines : [],
                            digitalProjectTypeList: data ? data.DigitalProjectTypes : [],
                        },
                        () => {
                           
                            if (this.state.ideaItem.CampaignName && this.state.campaignList) {
                                this.state.campaignList.map((campaign) => {
                                    if (campaign.Campaign === this.state.ideaItem.CampaignName) {
                                        this.setState({ campaignInsight: campaign.CampaignDescr }, () => {
                                            console.log("campaign insight =>", this.state.campaignInsight)
                                        })
                                    }
                                })
                            }
                            this.setToolsMethodologies()
                            this.setServiceLineSUB()
                        }
                    );
                }
            }
        } catch (error) {
            Toast.hide()
            Toast.fail("Error occured while getting metadata idea. Please try again!", 5000,
                () => { console.log(JSON.stringify(error)); }
            );
        }
    };

    fetchIdea = async() => {
        try{
            Toast.loading("Fetching Idea and Metadata...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
            if(response.ok){
                const data = await response.json();
                if(data){
                    Toast.hide();
                    console.log("fetch idea", data)
                    let localIdeasDB = data.IdeasDB ? data.IdeasDB[0] ? data.IdeasDB[0] : []:[];
                    this.setState({
                        ideaItem: data.ResultSets.Table1[0],
                        reviewComments: data.ReviewComments,
                        finalReviewComments: data.FinalReviewComments,
                        WorkflowStatus: data.ResultSets.Table1[0].WorkflowStatus,
                        Comment: data.ResultSets.Table1[0].Comment,

                        clientSignOffDate: data.ResultSets.Table1[0].CustSignOffDate ? new Date(data.ResultSets.Table1[0].CustSignOffDate).toLocaleDateString('en-CA').split('/').reverse().join('-') : null,
                        clientName: data ? data.ResultSets.Table1[0].CustName : null,
                        clientRole: data ? data.ResultSets.Table1[0].CustDesgn : null,
                        golOhr: data ? data.ResultSets.Table1[0].GOLOHR : "",
                        fpnaOhr: data ? data.ResultSets.Table1[0].FPnAOHR : null,
                        golFullname: data ? data.ResultSets.Table1[0].GOLName : null,
                        fpnaName: data ? data.ResultSets.Table1[0].FPnAName : null,
                        businessImpactValueArray: data.BIData ? data.BIData : [],
                        qcComments: data.QcComments ? data.QcComments : [],
                        qcCommentsWithVD: data.qcCommentsWithVD ? data.qcCommentsWithVD : [],
                        IsVDMonetizable: data.ResultSets.Table1[0].IsVDMonetizable === "Yes" ? true : false,
                        MonetizationStatus: data.ResultSets.Table1[0].MonetizationStatus ? data.ResultSets.Table1[0].MonetizationStatus : "",
                        duplicateQCOHR: data.ResultSets.Table1[0].QCOHR ? data.ResultSets.Table1[0].QCOHR : "",

                        filename1: data.ResultSets.Table1 ? data.ResultSets.Table1[0].ProjectPPTFileName : "",
                        clusterData: data.ClusterData ? data.ClusterData : [],


                        ideasAI: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0] : []:[],
                        coderOHRs: data.CodersTable ? data.CodersTable : [],

                        vdForComponent:data.BIData ? data.BIData : [],

                        

                    }, () => {

                        if (this.state.ideaItem.ModifiedDate) {
                            this.setState({
                                onInitPageTime: this.state.ideaItem.ModifiedDate,
                            })
                        }
                        if (this.state.ideaItem.ApprovalStatus === "Pending Documents") {
                            this.setState({
                                BlackBeltUserId: this.state.ideaItem.BlackBeltUserId,
                                BlackBeltUserName: this.state.ideaItem.BlackBeltUserName,
                                BlackBeltUserEmail: this.state.ideaItem.BlackBeltUserId + "@genpact.com",
                                blackBeltSelectedOption: {
                                    label: this.state.ideaItem.BlackBeltUserName,
                                    value: this.state.ideaItem.BlackBeltUserId
                                }
                            })
                            this.fetchBlackBeltOptions();
                            
                        }
                        
                        if (this.state.clusterData && this.state.clusterData.length > 0) {
                            const targetRecID = this.state.ideaItem.LeanID;
                            const filteredData = this.state.clusterData.filter(item => item.RecAlpha === targetRecID);

                            let getParentAlpa = "";
                            this.state.clusterData.map(item => {
                                if (item.RecAlpha === targetRecID) {
                                    getParentAlpa = item.ParentAlpha;
                                }
                            })
                            if (getParentAlpa) {
                                this.state.clusterData.map(item => {
                                    if (getParentAlpa === item.RecAlpha) {
                                        const selectedOption = {
                                            value: 0,
                                            label: item.ProjectType
                                        };
                                        this.state.projectTypeSelectedOption = selectedOption;
                                        this.setState({ projectTypeSelectedOption: selectedOption }, () => { })
                                    }
                                })
                            }

                            if (filteredData && filteredData.length > 0 && filteredData !== undefined && filteredData !== null) {
                                this.setState({ displayParentAlpha: filteredData[0].ParentAlpha }, () => { })
                                const selectedOption = {
                                    value: 0,
                                    label: filteredData[0].ParentAlpha
                                };
                                this.setState({ projectIDSelectedOption: selectedOption }, () => {
                                    this.setState({ projectIDSelectedOption: selectedOption }, () => {
                                        if (this.state.projectTypeSelectedOption && (this.state.projectTypeSelectedOption.label === null || this.state.projectTypeSelectedOption.label === "")) {
                                            if (this.state.projectIDSelectedOption.label.startsWith("GB")) {
                                                const selectedOptionGB = {
                                                    value: 0,
                                                    label: "GB"
                                                };
                                                this.state.projectTypeSelectedOption = selectedOptionGB;
                                                this.setState({ projectTypeSelectedOption: selectedOptionGB }, () => {
                                                    console.log(this.state.projectTypeSelectedOption)
                                                })
                                            } else {
                                                const selectedOptionBB = {
                                                    value: 0,
                                                    label: "BB"
                                                };
                                                this.state.projectTypeSelectedOption = selectedOptionBB;
                                                this.setState({ projectTypeSelectedOption: selectedOptionBB }, () => {
                                                    console.log(this.state.projectTypeSelectedOption)
                                                })
                                            }
                                        }
                                    })
                                })
                            } else {
                                this.setState({ displayParentAlpha: "", hideParentID: true }, () => { })
                            }
                        } else {
                            this.setState({ displayParentAlpha: "", hideParentID: true }, () => { })
                        }
                        if (this.state.clientSignOffDate === "1900-01-01") {
                            this.setState({ clientSignOffDate: "" }, () => { console.log(this.state.clientSignOffDate) })
                        }

                        if (this.state.ideaItem.CreatedDate) {
                            let created = new Date(this.state.ideaItem.CreatedDate);
                            let abc = new Date(DISPLAYPROJECTTHEME);
                            if (created.getTime() < abc.getTime()) {
                                //console.log("created date is lesser")
                                this.setState({ displayProjectTheme: true })
                            } else {
                                this.setState({ displayProjectTheme: false })
                                // console.log("created date is greater ")
                            }

                            let productivityWentLive = new Date(PRODUCTIVITYGOLIVEDATE);
                            if (created > productivityWentLive) {
                                this.setState({ toolsMethodologyMandatory: true })
                            } else {
                                this.setState({ toolsMethodologyMandatory: false })
                            }
                        }

                    });
                
                }
            }    
        }
        catch (error) {
            Toast.fail("Error while fetching idea. Please try again!", 3000, () => { });
            Toast.hide();
            console.log("error=>", error)
        };
    }


    setServiceLineSUB = () => {
        this.state.serviceLineList && this.state.serviceLineList.map((item) => {
            if (this.state.ideaItem.ServiceLineName === item.ServiceLineName) {
                this.setState({
                    ServiceLineSelectedOption: {
                        value: item.ServiceLineName,
                        label: item.ServiceLineName,
                    },
                });
            }
        });
        this.state.subServiceLineList && this.state.subServiceLineList.map((item) => {
            if (this.state.ideaItem.SubServiceLine === item.SubServiceLineName) {
                this.setState({
                    subServiceLineSelectedOption: {
                        value: item.SubServiceLineId,
                        label: item.SubServiceLineName,
                    },
                });
            }
        });
    }


    setCampaignName = () => {
        var opts = document.getElementById('ideationtype').childNodes;
        for (var i = 0; i < opts.length; i++) {
            if (i === this.state.ideaItem.CampaignTypeId - 1) {
                this.setState({
                    campaignName: opts[i].innerText
                });
            }
        }
    }



    validate = () => {

        let isValid = true;
        let styleStateObj = this.state.selectStyle;




        if (this.state.filename1 === "" || this.state.filename1 === undefined || this.state.filename1 === null) {
            console.log("filename 1", this.state.filename1)
            isValid = false
            Toast.fail("Please upload the project presentation deck file.", 3000, () => { });
        }


        if (this.state.showClientFields) {
            if (!this.state.clientName || this.state.clientName === null || this.state.clientName === undefined || this.state.clientName === "") {
                isValid = false
                Toast.fail("Please fill client name.", 3000, () => { });
            }
            if (!this.state.clientRole || this.state.clientRole === null || this.state.clientRole === undefined || this.state.clientRole === "") {
                isValid = false
                Toast.fail("Please fill client role.", 3000, () => { });
            }
            if (!this.state.clientSignOffDate || this.state.clientSignOffDate === null || this.state.clientSignOffDate === undefined || this.state.clientSignOffDate === "") {
                isValid = false
                Toast.fail("Please fill client sign-off date.", 3000, () => { });
            }
            if (this.state.ideaItem.CustomerSignoffFileName === null || this.state.ideaItem.CustomerSignoffFileName === undefined || this.state.ideaItem.CustomerSignoffFileName === "") {
                if (this.state.signOffFilename === null || this.state.signOffFilename === "" || this.state.signOffFilename === undefined || this.state.signOffFilename.length === 0 || !this.state.signOffFilename) {
                    isValid = false
                    Toast.fail("Please upload the client approval document.", 3000, () => { });
                }
            }
        }

        if (this.state.showGOLFields) {
            if (this.state.golOhr === "" || this.state.golOhr === null || this.state.golOhr === undefined) {
                isValid = false;
                Toast.fail("Please fill GOL OHR.", 3000, () => { })
            }

            if (this.state.golOhr) {
                if (this.state.golFullname === "" || this.state.golFullname === null || this.state.golFullname === undefined || this.state.golFullname.length === 0 || !this.state.golFullname) {
                    isValid = false;
                    Toast.fail("Please fill GOL OHR to fetch GOL name.")
                }
            }

            if (this.state.golFpnaFileDetails !== null || !this.state.golFpnaFileDetails) {
                if (this.state.golFpnaFileDetails[0].label === "" && this.state.golFpnaFileDetails[1].label === "") {
                    isValid = false;
                    Toast.fail("Please upload the GOL / FP&A approval document.", 3000, () => { })
                }
            }
            if (this.state.isFpnaRequired) {
                if (!this.state.fpnaOhr || this.state.fpnaOhr === null || this.state.fpnaOhr === undefined || this.state.fpnaOhr === "") {
                    isValid = false;
                    Toast.fail("Please fill FP&A OHR.", 3000, () => { })
                }
                if (this.state.fpnaOhr) {
                    if (!this.state.fpnaName || this.state.fpnaName === null || this.state.fpnaName === undefined || this.state.fpnaName === "") {
                        isValid = false;
                        Toast.fail("Please fill FP&A OHR to fetch FP&A Name.", 3000, () => { })
                    }
                }
            }



        }
        if (this.state.blackBeltSelectedOption === null ||
            this.state.blackBeltSelectedOption === undefined ||
            !this.state.blackBeltSelectedOption) {
            isValid = false;
            styleStateObj.blackBeltSelectedOption = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            styleStateObj.blackBeltSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        if (this.state.ServiceLineSelectedOption === null ||
            this.state.ServiceLineSelectedOption === undefined ||
            !this.state.ServiceLineSelectedOption) {
            isValid = false;
            styleStateObj.ServiceLineSelectedOption = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            styleStateObj.ServiceLineSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }


        if (this.state.subServiceLineSelectedOption === null ||
            this.state.subServiceLineSelectedOption === undefined ||
            !this.state.subServiceLineSelectedOption) {
            isValid = false;
            styleStateObj.subServiceLineSelectedOption = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            styleStateObj.subServiceLineSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }

        if (this.state.toolsMethodologyMandatory) {
            if (this.state.methodologySelectedOptions === null || this.state.methodologySelectedOptions === undefined || !this.state.methodologySelectedOptions || this.state.methodologySelectedOptions.length === 0) {
                isValid = false;
                styleStateObj.methodologySelectedOptions = selectStyle(false);
                this.setState({
                    selectStyle: styleStateObj,
                });
            }
            else {
                styleStateObj.methodologySelectedOptions = selectStyle(true);
                this.setState({
                    selectStyle: styleStateObj,
                });
            }
        }



        // validations copied from final-review-idea-page starts here
        if (this.state.ideaItem.CertificationLevelName === "Lean") {
            if (this.state.impactOptionSelected === null) {
                isValid = false;
                Toast.fail("Please select Value Delivery Type", 3000, () => { });
            }
        }


        if (this.state.ideaItem.CertificationLevelName === "Lean") {
            if (this.state.impactOptionSelected && this.state.impactOptionSelected.label !== NO_VD) {
                if (this.state.businessImpactValueArray.length === 0 || !this.state.businessImpactValueArray) {
                    Toast.fail("Value Delivery cannot be empty, please fill and resubmit.", 3000, () => { });
                    isValid = false;
                }
                console.log("business impact value array at validate function", this.state.businessImpactValueArray)

                let showFTEImpactError = false;
                let showDollarImpactError = false;
                let FTEGreaterThanDollar = false;
                let myBIMasterList = this.state.businessImpactMasterList && this.state.businessImpactMasterList;

                if (this.state.businessImpactValueArray) {
                    if (this.state.finalImpactDollar <= 0) {
                        Toast.fail("Total Dollar Impact cannot be zero. Please check and resubmit.", 3000, () => { });
                        isValid = false;
                    }
                    if (this.state.finalImpactFTE > 0 && this.state.finalImpactDollar <= 0) {
                        Toast.fail("Total Impact Dollar cannot be zero when FTE is non-zero. Please check and resubmit.", 3000, () => { });
                        isValid = false;
                    }
                    this.state.businessImpactValueArray.filter((item) => {
                        if (parseFloat(item.DollarImpact) === 0 || parseFloat(item.DollarImpact) === "" || !item.DollarImpact || item.DollarImpact === null) {
                            showDollarImpactError = true;
                        }
                        for (const pg_item of myBIMasterList) {
                            if (item.ImpactType === pg_item.pg_impacttype && item.MonetizableType === pg_item.pg_monetizabletype && item.BISubCategory === pg_item.pg_bisubcategory && pg_item.pg_isfteimpact === "Yes") {
                                if (!item.FTEImpact || parseFloat(item.FTEImpact) === 0 || item.FTEImpact === null || item.FTEImpact === undefined || item.FTEImpact === "") {
                                    showFTEImpactError = true;
                                }
                            }
                        }
                        if (item && item.isFTEPresent === true) {
                            if (parseFloat(item.FTEImpact) > parseFloat(item.DollarImpact)) {
                                FTEGreaterThanDollar = true;
                            }
                        }
                    });

                    if (showFTEImpactError === true) {
                        isValid = false;
                        Toast.fail("FTE Impact value cannot be zero", 3000, () => { });
                    }
                    if (showDollarImpactError === true) {
                        isValid = false;
                        Toast.fail("Dollar Impact value cannot be zero.", 3000, () => { });
                    }
                    if (FTEGreaterThanDollar === true) {
                        isValid = false;
                        Toast.fail("FTE impact value cannot be greater than dollar value", 3000, () => { });
                    }

                }

            }


            console.log("monetized project selected option at validate function",this.state.monetizableProjectSelectedOption)

            if (this.state.impactOptionSelected && this.state.impactOptionSelected.label !== NO_VD) {
                if (this.state.monetizableProjectSelectedOption === null ||
                    this.state.monetizableProjectSelectedOption.length === 0 ||
                    this.state.monetizableProjectSelectedOption === undefined
                ) {
                    isValid = false;
                    Toast.fail("Please select monetizatable project", 5000, () => { });
                }
            }

            if (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT) {
                if (this.state.businessImpactValueArray.length > 0) {
                    let impactGenpactTrue = this.state.businessImpactValueArray.some(vendor => vendor['ImpactType'] === IMPACT_TO_GENPACT)
                    let impactClientTrue = this.state.businessImpactValueArray.some(vendor => vendor['ImpactType'] === IMPACT_TO_CLIENT)
                    if (impactGenpactTrue === false) {
                        isValid = false;
                        Toast.fail('Please add both Impact types.', 3000, () => { })
                    }
                    if (impactClientTrue === false) {
                        isValid = false;
                        Toast.fail('Please add both Impact types.', 3000, () => { })
                    }
                }
            }


            if (this.state.impactOptionSelected) {
                if (this.state.monetizableProjectSelectedOption) {
                    if (this.state.monetizableProjectSelectedOption.label === "Yes") {
                        if (!this.state.monetizationStatusSelectedOption || this.state.monetizationStatusSelectedOption === null || this.state.monetizationStatusSelectedOption === undefined || this.state.monetizationStatusSelectedOption.length === 0) {
                            isValid = false;
                            Toast.fail("Since this project has been marked as Monetizable, monetizable status has to be selected", 5000, () => { })
                        }
                    }
                }
                if (this.state.monetizableProjectSelectedOption && this.state.monetizableProjectSelectedOption.label === "Yes" && this.state.monetizationStatusSelectedOption !== null) {
                    if ((this.state.businessImpactValueArray.filter(item => item.IsMonetized === "Yes")).length > 0) { }
                    else {
                        isValid = false;
                        Toast.fail("Since this is a monetizable project, there needs to be at least one impact type as ‘Impact at Genpact’ selected and category selected as a ‘Increase in Revenue’ .", 5000, () => { })
                    }
                }
                if (this.state.monetizableProjectSelectedOption && this.state.monetizableProjectSelectedOption.label === "Yes") {
                    if (this.state.monetizationStatusSelectedOption && this.state.monetizationStatusSelectedOption.label === "Approved by Client") {
                        if (this.state.SowID === "" || this.state.SowID === null || this.state.SowID === undefined || this.state.SowID.length === 0 || !this.state.SowID) {
                            isValid = false;
                            Toast.fail("Please fill SOW ID/SFDC/OLI ID for monetization", 3000, () => { })
                        }
                    }
                }

            }
        }

        return isValid;
    }

    submitIdea = () => {
        return new Promise((resolve, reject) => {
            let param = {};
            this.state.businessImpactValueArray = this.state.businessImpactValueArray.map(item => ({
                ...item,
                pg_srno: item.SrNo,
                dollarValue: item.DollarImpact,
                fteValue: item.FTEImpact
            })).map(item => {
                return item;

            });
            let filteredBIData = this.state.businessImpactValueArray.filter(function (e) {
                return (e !== null && e !== undefined);
            });
            let MethodolodyToolsSelectedLabels = '';
            if (this.state.methodologySelectedOptions) {
                MethodolodyToolsSelectedLabels = this.state.methodologySelectedOptions.map(option => `${option.label}`).join('|');
            }

            let CodersTableWithSOrd = this.state.coderOHRs && this.state.coderOHRs.map((item, index) => ({ ...item, SOrd: index }));

            let checkifBiContainsProductivityLineItems = false;
            checkifBiContainsProductivityLineItems = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some(item => item.PValid && item.PValid.length > 0);

            param = {
                BlackBeltUserId: Number(this.state.BlackBeltUserId) ? Number(this.state.BlackBeltUserId) : this.state.ideaItem.BlackBeltUserId,
                BlackBeltUserName: this.state.BlackBeltUserName ? this.state.BlackBeltUserName : this.state.ideaItem.BlackBeltUserName,
                BlackBeltUserEmail: this.state.BlackBeltUserEmail ? this.state.BlackBeltUserEmail : this.state.ideaItem.BlackBeltUserEmail,

                ServiceLineName: this.state.ServiceLineSelectedOption && this.state.ServiceLineSelectedOption.label,
                SubServiceLine: this.state.subServiceLineSelectedOption && this.state.subServiceLineSelectedOption.label,

                MethodologyName: MethodolodyToolsSelectedLabels,
                IdeaId: this.props.location.state,
                BusinessImpactData: filteredBIData,
                FinalImpactDollar: this.state.finalImpactDollar ? this.state.finalImpactDollar : null,
                FinalImpactFTE: this.state.finalImpactFTE ? this.state.finalImpactFTE : null,

                VDType: this.state.impactOptionSelected ? this.state.impactOptionSelected.label : this.state.ideaItem.VDType,
                SowID: this.state.SowID ? this.state.SowID : (this.state.ideaItem.SowID ? this.state.ideaItem.SowID : ""),
                IsVDMonetizable: this.state.monetizableProjectSelectedOption ? this.state.monetizableProjectSelectedOption.label : (this.state.IsVDMonetizable ? this.state.IsVDMonetizable : ""),
                MonetizationStatus: this.state.monetizationStatusSelectedOption ? this.state.monetizationStatusSelectedOption.label : this.state.ideaItem.MonetizationStatus,
                case: "new",
                casetype: "OwnerUploadDocuments",
                updaterRole: "Idea Owner",

                CampaignName: this.state.ideaItem.CampaignName,
                TransformationLeverName: this.state.ideaItem.TransformationLeverName,
                // IsVDMonetizable: this.state.impactOptionSelected ? (this.state.impactOptionSelected.label=== NO_VD ? "No" : ""):"",
                // DB api mappings starts here

                LeanID: this.state.ideaItem.LeanID ? this.state.ideaItem.LeanID : "",
                checkifBiContainsProductivityLineItems: checkifBiContainsProductivityLineItems,

                IdeaName: this.state.ideaItem.IdeaName ? this.state.ideaItem.IdeaName : "",
                UpdaterOHR: this.state.ideaItem.OwnerOHR ? this.state.ideaItem.OwnerOHR : this.sessionData.profile.oHRId,
                UpdaterName: this.state.ideaItem.OwnerName ? this.state.ideaItem.OwnerName : this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
                UpdaterEmail: this.state.ideaItem.OwnerEmail ? this.state.ideaItem.OwnerEmail : this.sessionData.profile.oHRId + "@genpact.com",
                ApprovalStatus: "Documents Uploaded",
                WorkflowStatus:"Approved",
                Action: "Idea Owner uploaded documents",
                UpdaterRole: "Idea Owner",

                CodersField: CodersTableWithSOrd ? CodersTableWithSOrd : [],

                IsZeroImpactProject: this.state.impactOptionSelected && this.state.impactOptionSelected.label === NO_VD ? 1 : 0
            }
            console.log(param)
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };
            fetch(`${REVIEW_IDEA_URL}`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    Toast.hide();
                    if (data.Message === "Documents uploaded succesfully") {
                        resolve()
                    } else {
                        console.log(data)
                        reject()
                    }
                })
                .catch = (err) => {
                    console.log('error =>', JSON.stringify(err))
                    reject()
                }
        })
    }

    

    uploadDocuments = (e) => {
        return new Promise((resolve, reject) => {
            let param = {
                ProjectPPTDeck: this.state.base64File1,
                ProjectPPTFilename: this.state.filename1 ? this.state.filename1 : this.state.ideaItem.ProjectPPTFileName,
                ProjectPPTType: this.state.fileType1 ? this.state.fileType1 : this.state.ideaItem.ProjectPPTType,

                CustomerLeadSignOff: this.state.signOffContent,
                CustomerSignoffFilename: this.state.signOffFilename ? this.state.signOffFilename : this.state.ideaItem.CustomerSignoffFileName,
                CustomerSignoffType: this.state.signOffFileType ? this.state.signOffFileType : this.state.ideaItem.CustomerSignoffType,

                golApproval: this.state.base64File3,
                golApprovalFileName: this.state.filename3,
                golApprovalType: this.state.fileType3,

                fpnaApproval: this.state.base64File4,
                fpnaApprovalFileName: this.state.filename4,
                fpnaApprovalType: this.state.fileType4,
                BlackBeltUserEmail: this.state.BlackBeltUserEmail,
                BlackBeltUserName: this.state.BlackBeltUserName,
                IdeaId: this.props.location.state,
                ModifiedByOHR: this.sessionData.profile.oHRId,
                Role: "Idea Owner",
                // updaterAction:"Idea Owner uploaded documents",
                // VDType:this.state.impactOptionSelected.label,

                ClientName: this.state.clientName,
                ClientRole: this.state.clientRole,
                ClientSignOffDate: this.state.clientSignOffDate,
                GolOhr: this.state.golFullname ? this.state.golOhr : "",
                FpnaName: this.state.fpnaName,
                GolFullname: this.state.golFullname,
                FpnaOhr: this.state.fpnaName ? this.state.fpnaOhr : "",

                updaterRole: "Idea Owner",
                CampaignName: this.state.ideaItem.CampaignName,
                TransformationLeverName: this.state.ideaItem.TransformationLeverName,

            }
            console.log(param)
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };
            fetch(`${UPDATE_IDEA_URL}documentsonly=''`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    resolve();
                })
                .catch=(err)=>{
                    reject();
                    console.log("error =>", JSON.stringify(err))
                }
        })
    }

    mainUpdateIdea = async (e) => {
        if (this.validate()) {
            if (window.confirm("Are you sure you want to update the Project ?")) {
                Toast.loading("Updating Lean Project...", () => { });
                try {
                    await Promise.all([this.submitIdea(), this.uploadDocuments()]);
                    Toast.hide();
                    Toast.info("Lean project updated successfully!", 4000, () => {
                        let redirectURL = "/review-page";
                        if (this.state.approvalPage) {
                            if (this.state.approvalPage === PROJECT_VIEW) {
                                redirectURL = "/list-projects-page";
                                this.props.history.push(redirectURL);
                            } else {
                                redirectURL = redirectURL + "?page=" + this.state.approvalPage;
                                this.props.history.push(redirectURL);
                            }
                        }
                        else {
                            this.props.history.push(redirectURL);
                        }
                    });
                } catch (error) {
                    Toast.fail('There was an error updating the lean project.', 3000);
                    console.error("Error =>", error);
                    Toast.hide();
                }
            }
        }
        else {
            Toast.fail('Required fields are missing or have invalid values. Please correct and try again.', 3000);
            return;
        }
    };



    cancelEvent = () => {
        let redirectURL = "/review-page";
        if (this.state.approvalPage) {
            if (this.state.approvalPage === PROJECT_VIEW) {
                redirectURL = "/list-projects-page";
                // this.props.history.push(redirectURL);
                this.props.history.push({
                    pathname: redirectURL,
                    propsList: this.state.propsData
                })
            } else {
                redirectURL = redirectURL + "?page=" + this.state.approvalPage;
                this.props.history.push(redirectURL);
            }
        }
        else {
            // this.props.history.push(redirectURL);
            this.props.history.push({
                pathname: redirectURL,
                propsList: this.state.propsData
            })
        }
    }

    showSignOffContent = async () => {
        try {
            Toast.loading("Fetching Customer Sign-off content...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let signoffFileType = this.state.ideaItem.CustomerSignoffType;
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${SIGNOFF_CONTENT}=true&case=doc`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    const signoffMetadata = data.SignoffContent ? data.SignoffContent : "";
                    const signoffContent = "data:" + signoffFileType + ";base64," + signoffMetadata;
                    if (signoffContent) {
                        var fileData = signoffContent;
                        var fileName = this.state.ideaItem.CustomerSignoffFileName;
                        var w = window.open("");
                        const downloadLink = w.document.createElement("a");
                        downloadLink.href = fileData;
                        downloadLink.download = fileName;
                        downloadLink.click();
                        Toast.hide();
                    }
                }
            }
        }
        catch (error) {
            Toast.hide();
            console.log(error)
            Toast.fail("Error while fetching Customer sign-off content. Please try again!", 3000, () => { });
        }
    }

    showGOLContent = async () => {
        try {
            Toast.loading("Fetching GOL Approval content...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let goleFileType = this.state.fileType3;
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${PPT_CONTENT}=true&golcontent=true&case=doc`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {

                    const fileContent = data.golContent ? data.golContent : "";
                    const signoffContent = "data:" + goleFileType + ";base64," + fileContent;
                    if (signoffContent) {
                        var fileData = signoffContent;
                        var fileName = this.state.ideaItem.GOLFileName;
                        var w = window.open("");
                        const downloadLink = w.document.createElement("a");
                        downloadLink.href = fileData;
                        downloadLink.download = fileName;
                        downloadLink.click();
                        Toast.hide();
                    }
                }
            }
        }
        catch (error) {
            Toast.hide()
            Toast.fail("Error while fetching Project Deck content. Please try again!", 3000, () => { });
            console.log(error)
        }
    }

    showFPnAContent = async () => {
        try {
            Toast.loading("Fetching FP&A content...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let fpnaFileType = this.state.fileType4;
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${PPT_CONTENT}=true&fpnacontent=true&case=doc`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    console.log("file download data =>",data)
                    const signoffMetadata = data.fpnaContent ? data.fpnaContent : "";
                    const signoffContent = "data:" + fpnaFileType + ";base64," + signoffMetadata;
                    if (signoffContent) {
                        var fileData = signoffContent;
                        var fileName = this.state.ideaItem.FPnAFileName;
                        var w = window.open("");
                        const downloadLink = w.document.createElement("a");
                        downloadLink.href = fileData;
                        downloadLink.download = fileName;
                        downloadLink.click();
                        Toast.hide();
                    }
                }
            }
        }
        catch (error) {
            Toast.hide();
            console.log(error)
            Toast.fail("Error while fetching FP&A approval content. Please try again!", 3000, () => { });
        }
    }

    formatDateStringWithTime(dateparam) {
        return dateparam.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    formatDateString(dateparam) {
        return dateparam.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    }

    validateComment = () => {
        let isValid = true;
        let styleStateObj = this.state.selectStyle;

        if (!this.state.Comments || this.state.Comments === "") {
            isValid = false;
            styleStateObj.comment = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj
            })
        }
        else {
            if (this.state.Comments.length > 500) {
                Toast.fail("Comment cannot be more than 500 characters, please change and resubmit.", 3000);
                isValid = false;
                styleStateObj.comment = textBoxValidation(false);
                this.setState({
                    selectStyle: styleStateObj
                })
            }
            else {
                styleStateObj.comment = { ...textBoxValidation(true), border: "1px solid lightgrey" };
                this.setState({
                    selectStyle: styleStateObj
                })
            }
        }
        return isValid;
    }

    handleCommentChange = (event) => {
        this.setState({
            Comments: event.target.value
        });
    }
    handleUpdateTranscriptCancelRequest = (e) => {
        let commentChange = e.trim();
        this.setState({
            Comments: commentChange
        });
    }

    submitEvent = () => {
        if (this.validateComment()) {
            let checkifOHRsAreUploaded = false;
            checkifOHRsAreUploaded = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some(item => item.PValid && item.PValid === "Yes");

            if (window.confirm("Are you sure you want to cancel this Project?")) {
                Toast.loading("Cancellation is in process...", () => { });
                let param = {
                    OnInitPageTime: this.state.onInitPageTime,
                    IdeaId: this.props.location.state,
                    ApprovalStatus: AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION,
                    UpdaterOHR: this.sessionData.profile.oHRId,
                    UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                    UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
                    comment: this.state.Comments,
                    WorkflowStatus: this.state.ideaItem.WorkflowStatus,
                    ProjectStatus: this.state.ideaItem.ApprovalStatus,
                    checkifOHRsAreUploaded: checkifOHRsAreUploaded
                }
                console.log(param)
                const requestOptions = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + this.accessToken,
                    },
                    body: JSON.stringify(param)
                };
                fetch(`${REVIEW_IDEA_URL}`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        console.log(data)
                        Toast.hide();
                        Toast.success('Cancel request sent successfully.', 3000, () => {
                            console.log(JSON.stringify(data));
                            let redirectURL = "/review-page";
                            if (this.state.approvalPage) {
                                redirectURL = redirectURL + "?page=" + this.state.approvalPage;
                            }
                            window.location = redirectURL;
                        });

                    });
            }
        }
        else {
            Toast.fail("Please enter comment.", 3000, () => { });
        }
    }

    cancelRequest = () => {
        Toast.info("Once cancelled you cannot have the project reinitiated. You will need to start the project from scratch", 3000, () => { });
        this.setState({
            cancelRequest: !this.state.cancelRequest,
        })
    }


    toggleTranscriptFunction = (id) => {
        this.setState({ speechModal: !this.state.speechModal, modalIndex: id })
    }

    closeModalFunction = () => {
        this.setState({ speechModal: false })
    }



    showPPTContent = async () => {
        try {
            Toast.loading("Fetching Project PPT Deck content...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let projectFileType = this.state.projectFileType;
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${PPT_CONTENT}=true&case=doc`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    const projectDeckMetadata = data.PPTContent ? data.PPTContent : "";
                    const projectContent = "data:" + projectFileType + ";base64," + projectDeckMetadata;
                    if (projectContent) {
                        var fileData = projectContent;
                        var fileName = this.state.ideaItem.ProjectPPTFileName;
                        var w = window.open("");
                        const downloadLink = w.document.createElement("a");
                        downloadLink.href = fileData;
                        downloadLink.download = fileName;
                        downloadLink.click();
                        Toast.hide();
                    }
                }
            }
        }
        catch (error) {
            Toast.hide()
            console.log(error)
            Toast.fail("Error while fetching Project Deck content. Please try again!", 3000, () => { });
        }
    }

    newBusinessImpactSummary() {
        let myArray = [...this.state.businessImpactValueArray];
        const groupedData = myArray.reduce((accumulator, currentValue) => {
            const impactType = currentValue.impactType;
            const monetizableType = currentValue.monetizableType;
            const fteValue = parseFloat(currentValue.fteValue) || 0.0;
            const dollarValue = parseFloat(currentValue.dollarValue) || 0.0;

            const existingRow = accumulator.find(row => row.impactType === impactType && row.monetizableType === monetizableType);
            if (existingRow) {
                existingRow.fteValue += fteValue
                existingRow.dollarValue += dollarValue
            } else {
                accumulator.push({ impactType, monetizableType, fteValue, dollarValue });
            }
            return accumulator;
        }, []);
        this.setState({ summaryArray: groupedData }, () => { });
        this.setState({ businessImpactValueArray: this.state.businessImpactValueArray }, () => { })

        let isFpnaRequired = false;
        this.state.businessImpactValueArray && this.state.businessImpactValueArray.map((item) => {
            if (item.ImpactType === IMPACT_TO_GENPACT) {
                if (item.MonetizableType === "Increase in Revenue" || item.MonetizableType === "Reduction in Cost" || item.MonetizableType === "Productivity") {
                    isFpnaRequired = true;
                }
            }
            if (item.MonetizableType && item.MonetizableType === "Productivity") {
                isFpnaRequired = true;
            }
        })
        this.setState({ isFpnaRequired: isFpnaRequired }, () => { })

        if (this.state.impactOptionSelected && (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT || this.state.impactOptionSelected.label === VD_TO_CLIENT)) {
            let clientNonProductivity = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some((e) => e.ImpactType === IMPACT_TO_CLIENT && ["Increase in Revenue", "Reduction in Cost", "Cash Impact", "Others"].includes(e.MonetizableType));
            if (clientNonProductivity) {
                this.setState({ showClientFields: true }, () => { })
            } else {
                this.setState({ showClientFields: false }, () => { })
                let genpactNonProducitivity = this.state.businessImpactValueArray.some((e) => e.ImpactType === IMPACT_TO_GENPACT && ["Increase in Revenue", "Reduction in Cost", "Cash Impact", "Others"].includes(e.MonetizableType));
                if (genpactNonProducitivity) {

                } else {
                    this.setState({ showClientFields: false }, () => { })
                }
            }
        }

        // if (this.state.impactOptionSelected && (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT || this.state.impactOptionSelected.label === VD_TO_CLIENT)) {
        //     let ifVDContainsProductivityCategory = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some(item => item.MonetizableType === "Productivity");
        //     if(ifVDContainsProductivityCategory){
        //         let abc = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some((e) => ["Increase in Revenue", "Reduction in Cost","Cash Impact","Others"].includes(e.MonetizableType))
        //         if(abc){
        //             this.setState({ showClientFields: true }, () => { })
        //         }else{
        //             this.setState({ showClientFields: false }, () => { })
        //         }
        //     }else{
        //         this.setState({ showClientFields: true }, () => { })
        //     }
        // }


        // if (this.state.impactOptionSelected && (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT || this.state.impactOptionSelected.label === VD_TO_CLIENT)) {
        //     let ifVDContainsClient = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some(item => (item.ImpactType === IMPACT_TO_CLIENT && item.MonetizableType === "Productivity"));
        //     if (ifVDContainsClient) {
        //         this.setState({ showClientFields: false }, () => { })
        //     } else {
        //         this.setState({ showClientFields: true }, () => { })
        //     }
        // }
    }

    pull_data = (businessImpactValueArray) => {
        console.log('pull_data =>',businessImpactValueArray)
        this.setState({ businessImpactValueArray: businessImpactValueArray }, () => {
            this.newBusinessImpactSummary()
        })
        let dollarTotal = 0.0;
        let fteValue = 0.0;
        this.state.businessImpactValueArray.map((item) => {
            if (item && item.DollarImpact) {
                dollarTotal += parseFloat(item.DollarImpact);
            }
            if (item && item.dollarValue) {
                dollarTotal += parseFloat(item.dollarValue);
            }
            if (item && item.FTEImpact) {
                fteValue += parseFloat(item.FTEImpact)
            }
            if (item && item.fteValue) {
                fteValue += parseFloat(item.fteValue)
            }
        })
        this.setState({ finalImpactDollar: dollarTotal }, () => {
            // console.log("inside call back function $ total",this.state.finalImpactDollar)
        })
        this.setState({ finalImpactFTE: fteValue }, () => {
            // console.log("inside call back function fte value",this.state.finalImpactFTE)
        })
    }
    remove_bi_data_after_delete = (filteredIdeaArray) => {
        // console.log("bi recieved in pull data for delete function",filteredIdeaArray)
        if (filteredIdeaArray) {
            this.setState({ businessImpactValueArray: filteredIdeaArray }, () => {
                this.newBusinessImpactSummary()
                let dollarTotal = 0.0;
                let fteValue = 0.0;
                this.state.businessImpactValueArray.map((item) => {
                    if (item && item.DollarImpact) {
                        dollarTotal += parseFloat(item.DollarImpact);
                    }
                    if (item && item.dollarValue) {
                        dollarTotal += parseFloat(item.dollarValue);
                    }
                    if (item && item.FTEImpact) {
                        fteValue += parseFloat(item.FTEImpact)
                    }
                    if (item && item.fteValue) {
                        fteValue += parseFloat(item.fteValue)
                    }
                })
                this.setState({ finalImpactDollar: dollarTotal }, () => {
                    //console.log("inside call back function $ total",this.state.finalImpactDollar)
                })
                this.setState({ finalImpactFTE: fteValue }, () => {
                    // console.log("inside call back function fte value",this.state.finalImpactFTE)
                })

            })
        }

    }

    pull_file_data = ({ fileName, fileType, fileContent, showClientApprovalFields, FPnAOHRMonetization }) => {
        if (fileName) {
            this.setState({ FPnAFileNameMonetization: fileName }, () => { })
        }
        if (fileType) {
            this.setState({ FPnAFileTypeMonetization: fileType }, () => { })
        }
        if (fileContent) {
            this.setState({ FPnAFileMonetization: fileContent }, () => { })
        }
        this.setState({ showClientApprovalFields: showClientApprovalFields }, () => { })
        this.setState({ FPnAOHRMonetization: FPnAOHRMonetization }, () => { })
    }
    pull_monetization_sowId = (localSowId) => {
        this.setState({ SowID: localSowId }, () => { })
    }
    pull_monetization_fpna_name = (localFpnaName) => {
        this.setState({ FPnANameMonetization: localFpnaName }, () => { })
    }

    pullMonetizedTotal = ({ fteValue, dollarValue }) => {
        if (fteValue) {
            this.setState({ totalMonetizedDollar: fteValue }, () => { })
        }
        if (dollarValue) {
            this.setState({ totalMonetizedFTE: dollarValue }, () => { })
        }
    }
    pull_monetizableProject = (e) => {
        //console.log("monetization value received at pull function =>",e)
        if (e) {
            this.setState({ monetizableProjectSelectedOption: e }, () => {
                if (this.state.monetizableProjectSelectedOption.label === "No") {
                    this.setState({ monetizationStatusSelectedOption: null }, () => { })
                }
                //console.log("monetization project selected opiton is =>",this.state.monetizableProjectSelectedOption)
            })
        }
    }
    pull_monetizableStatus = (e) => {
        this.setState({ monetizationStatusSelectedOption: e }, () => {
            //console.log("selected monetization status is ",this.state.monetizationStatusSelectedOption)
        })
    }
    handleVDTypeChange = (e) => {
        if (e) {
            this.setState({ impactOptionSelected: e, impactChanged: true }, () => {
                if (this.state.impactOptionSelected.label === NO_VD) {
                    this.setState({
                        signOffFilename: "",
                        signOffFileType: "",
                        signOffContent: "",
                        filename3: "",
                        fileType3: "",
                        base64File3: "",
                        filename4: "",
                        fileType4: "",
                        base64File4: "",
                        clientName: "",
                        clientRole: "",
                        clientSignOffDate: "",
                        fpnaName: "",
                        golFullname: "",
                        fpnaOhr: "",
                        golOhr: "",
                        showClientFields: false,
                        showGOLFields: false,
                        finalImpactDollar: 0,
                        monetizableProjectSelectedOption: null,
                        businessImpactValueArray: [],
                        IsVDMonetizable: "",
                        MonetizationStatus: ""
                    })
                }
                if (this.state.impactOptionSelected.label === VD_TO_CLIENT) {
                    this.setState({ showClientFields: true, showGOLFields: true })
                }
                if (this.state.impactOptionSelected.label === VD_TO_GENPACT) {
                    this.setState({ showClientFields: false, showGOLFields: true })
                }
                if (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT) {
                    this.setState({ showClientFields: true, showGOLFields: true })
                }
            })
        }
    }
    fetchFPAOHRforIncreaseInRevenue = (e) => {
        if (e === true) {
            this.setState({ appropriateAttachment: true }, () => { })
        } else {
            this.setState({ appropriateAttachment: false }, () => { })
        }
    }

    // function for FPNAGOL component starts here
    // ppt deck file details
    pullPPTDeck = (fileName, fileType, fileContent) => {
        this.setState({ filename1: fileName, fileType1: fileType, base64File1: fileContent }, () => { })
    }
    pullClientDocName = (fileName) => {
        this.setState({ signOffFilename: fileName, }, () => { })
    }
    pullClientDocType = (fileType) => {
        if (fileType) {
            this.setState({ signOffFileType: fileType }, () => { })
        }
    }
    pullClientDocContent = (fileContent) => {
        if (fileContent) {
            this.setState({ signOffContent: fileContent }, () => { })
        }
    }

    // gol file details
    pullgolFileName = (fileName) => {
        this.setState({ filename3: fileName }, () => {
            //console.log("gol approval doc name",this.state.filename3)      
        })
    }
    pullgolFileType = (fileType) => {
        this.setState({ fileType3: fileType }, () => {
            //console.log("gol approval doc type",this.state.fileType3)      
        })
    }
    pullgolContent = (fileContent) => {
        this.setState({ base64File3: fileContent }, () => {
            //console.log("gol approval doc content",this.state.base64File3)      
        })
    }

    // fpna file details
    pullfpnafileName = (fileName) => {
        if (fileName) {
            this.setState({ filename4: fileName }, () => {
                // console.log("fpna doc name",this.state.filename4)
            })
        }
    }
    pullfpnafileType = (fileType) => {
        if (fileType) {
            this.setState({ fileType4: fileType }, () => {
                // console.log("fpna doc type",this.state.fileType4)
            })
        }
    }
    pullfpnafileContent = (fileContent) => {
        this.setState({ base64File4: fileContent }, () => {
            // console.log("fpna doc file content",this.state.base64File4)
        })
    }
    pullClientName = (e) => {
        this.setState({ clientName: e }, () => {
            //console.log(this.state.clientName)
        })
    }
    pullClientRole = (e) => {
        this.setState({ clientRole: e }, () => {
            //console.log(this.state.clientRole)
        })
    }
    pullClientSignOff = (e) => {
        this.setState({ clientSignOffDate: e }, () => {
            //console.log(this.state.clientSignOffDate)
        })
    }
    pullFpnaName = (name) => {
        //console.log("fpna name",name)
        this.setState({ fpnaName: name }, () => {
            //console.log(this.state.fpnaName)
        })
    }
    pullGolName = (name) => {
        //console.log("gol name",name)
        this.setState({ golFullname: name }, () => {
            //console.log(this.state.golFullname)
        })
    }
    pullFpnaOhr = (e) => {
        this.setState({ fpnaOhr: e }, () => {
           // console.log(this.state.fpnaOhr)
        })
    }
    pullGolOhr = (e) => {
        this.setState({ golOhr: e }, () => {
            //console.log(this.state.golOhr)
        })
    }
    pull_fileDetails = (obj) => {
        console.log(obj)
        this.setState({ golFpnaFileDetails: obj }, () => {
            //console.log(this.state.golFpnaFileDetails)
        })
    }

    pull_monetization_fpna_ohr = (localFpnaohr) => {
        //console.log("fpna ohr from pull function => ",localFpnaohr)
        this.setState({ FPnAOHRMonetization: localFpnaohr }, () => { })
    }
    pullCategoryNotListed = (localShowHref) => {
        this.setState({ showHrefModal: localShowHref }, () => {
            //console.log("hrf modal =>", this.state.showHrefModal)
        });
    };
    pullMonetizationGOLName = (localGOLName) => {
        //console.log("local gol name from pull function",localGOLName)
        this.setState({ golMonetizationName: localGOLName }, () => {
        })
    }

    pullMonetizationGOLOhr = (localGOLOhr) => {
        this.setState({ golMonetizationOhr: localGOLOhr }, () => {
            //console.log("gol ohr monetization",this.state.golMonetizationOhr)
        })
    }
    // function for FPNAGOL component ends here



    // clustering function starts here

    showClusterModal = () => {
        if (this.state.ideaItem.LeanID !== "" || this.state.ideaItem.LeanID !== null || this.state.ideaItem.LeanID !== undefined || !this.state.ideaItem.LeanID) {
            this.setState({
                clusterModal: !this.state.clusterModal,
            })

        }
    }
    changeProjectType = (e) => {
        this.setState({ projectIDSelectedOption: null }, () => { })
        if (e) {
            this.setState({ projectTypeSelectedOption: e }, () => {
                Toast.loading("Fetching Cluster Projects...", () => { });
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + this.accessToken,
                    }
                };
                let encodedAccount = encodeURIComponent(this.state.ideaItem.AccountManual)
                let encodedVertical = encodeURIComponent(this.state.ideaItem.VerticalManual)
                fetch(`${GET_IDEA_URL}Account=${encodedAccount}&Vertical=${encodedVertical}&ProjectType=${this.state.projectTypeSelectedOption.label}&IdeaId=${this.state.ideaItem.IdeaId}&case=data&casetype=fetchclusterprojects&mucid=muc001`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        Toast.hide();
                        this.setState({
                            clustorProjects: data.ClusterProjects
                        }, () => { });
                    })
                    .catch(error => {
                        Toast.fail("Error while fetching cluster projects. Please try again!", 3000, () => { });
                        Toast.hide();
                        console.log(error)
                    });
            })
        }
    }

    displayProjectID = () => {
        if (this.state.clustorProjects) {
            let options = [];
            if (this.state.clusterOptionSearched) {
                this.state.clustorProjects.map((item, index) => {
                    options.push({
                        value: index,
                        Display: item.pg_projectid,
                        label: item.pg_projectid + " - " + item.pg_projowner,
                    });
                });
            } else {
                this.state.clustorProjects.map((item, index) => {
                    if (index < 19) {
                        options.push({
                            value: index,
                            Display: item.pg_projectid,
                            label: item.pg_projectid + " - " + item.pg_projowner,
                        });
                    }
                });
            }
            return options;
        }
    };

    handleClusterProjectInputChange = (inputValue) => {
        if (inputValue && inputValue.length > 0) {
            this.setState({ clusterOptionSearched: true }, () => { })
        } else {
            this.setState({ clusterOptionSearched: false }, () => { })
        }
    }


    changeProjectID = (e) => {
        this.setState({ projectIDSelectedOption: e, isClusterSaveDisabled: false }, () => {
            this.state.clustorProjects.map((item, index) => {
                if (item.pg_projectid === this.state.projectIDSelectedOption.Display) {
                    this.setState({ guid: item.msdyn_projectid, parentProjectName: item.msdyn_subject }, () => { })
                }
            })
        })
    }
    saveParentLink = async () => {
        if (this.state.ideaItem.ApprovalStatus && this.state.ideaItem.ApprovalStatus !== "Rejected" && this.state.projectTypeSelectedOption && this.state.projectIDSelectedOption) {
            if (window.confirm("Are you sure you'd like to add Project ID: " + this.state.projectIDSelectedOption.Display + " as the Parent Project ID?")) {
                if ((parseInt(this.state.ideaItem.OwnerOHR) === parseInt(this.sessionData.profile.oHRId)) ||
                    (parseInt(this.state.ideaItem.BlackBeltUserId) === parseInt(this.sessionData.profile.oHRId))) {
                    if (this.state.projectTypeSelectedOption && this.state.projectIDSelectedOption) {
                        Toast.loading("Linking...", () => { });
                        let param = {
                            case: "new",
                            casetype: "updatecluster",
                            RecID: this.props.location.state,
                            RecAlpha: this.state.ideaItem.LeanID,
                            ParentRecID: this.state.guid,
                            ParentAlpha: this.state.projectIDSelectedOption ? this.state.projectIDSelectedOption.Display : "",
                            UpdatedByName: this.sessionData ? this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName : "",
                            UpdatedByOHR: this.sessionData ? this.sessionData.profile.oHRId : " ",
                            ParentProjectType: this.state.projectTypeSelectedOption ? this.state.projectTypeSelectedOption.label : "",
                            Vertical: this.state.ideaItem ? this.state.ideaItem.VerticalManual : "",
                            Account: this.state.ideaItem ? this.state.ideaItem.AccountManual : "",
                            childProjectOwner: this.state.ideaItem.OwnerName,
                            childProjectName: this.state.ideaItem.IdeaName,
                            parentProjectName: this.state.parentProjectName,
                        }
                        console.log(param)
                        
                        const requestOptions = {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                "Authorization": "Bearer " + this.accessToken,
                            },
                            body: JSON.stringify(param)
                        };
                        fetch(`${DELEGATE_IDEA_URL}`, requestOptions)
                            .then(response => response.json())
                            .then(data => {
                                Toast.success('Parent linked successfully!', 5000, () => {
                                    this.setState({
                                        clusterModal: !this.state.clusterModal,
                                    })
                                    this.updateClusterData();
                                })
                                this.setState({ isClusterSaveDisabled: true }, () => { })
                            })
                            .catch(error => {
                                console.log(error)
                                Toast.fail("Parent linked failed", 3000, () => { })
                            });


                    } else {
                        Toast.fail("Please select project type & project ID", 3000, () => { })
                    }
                } else {
                    Toast.fail("Only idea owner & idea BB can link the ideas", 3000, () => { })
                }
            }
        } else {
            Toast.fail("Rejected ideas cannot be linked.", 3000, () => { })
        }

    }
    removeParentFunc = () => {
        if (this.state.ideaItem.ApprovalStatus && this.state.ideaItem.ApprovalStatus !== "Rejected") {
            if ((parseInt(this.state.ideaItem.OwnerOHR) === parseInt(this.sessionData.profile.oHRId)) ||
                (parseInt(this.state.ideaItem.BlackBeltUserId) === parseInt(this.sessionData.profile.oHRId))) {
                if (!this.state.clusterData || this.state.clusterData.length === 0) {
                    if ((this.state.projectTypeSelectedOption === null || this.state.projectTypeSelectedOption === undefined || !this.state.projectTypeSelectedOption) &&
                        (this.state.projectIDSelectedOption === null || this.state.projectIDSelectedOption === undefined || !this.state.projectIDSelectedOption)
                    ) {
                        Toast.fail("Only linked ideas can only be removed", 3000, () => { })
                    }
                }
                if (this.state.clusterData && this.state.clusterData.length > 0) {
                    console.log("project id", this.state.projectIDSelectedOption)
                    if (this.state.projectTypeSelectedOption && this.state.projectIDSelectedOption) {
                        if (window.confirm("Are you sure you'd like to remove Project ID: " + this.state.projectIDSelectedOption.label + " as the Parent Project ID?")) {
                            Toast.loading("Removing parent link...", () => { });
                            let param = {
                                case: "new",
                                casetype: "updatecluster",
                                RecID: this.props.location.state,
                                RecAlpha: this.state.ideaItem.LeanID,
                                ParentRecID: "",
                                ParentAlpha: "",
                                UpdatedByName: this.sessionData ? this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName : "",
                                UpdatedByOHR: this.sessionData ? this.sessionData.profile.oHRId : " ",
                                Vertical: this.state.ideaItem ? this.state.ideaItem.VerticalManual : "",
                                Account: this.state.ideaItem ? this.state.ideaItem.AccountManual : "",
                                childProjectOwner: this.state.ideaItem.OwnerName,
                                childProjectName: this.state.ideaItem.IdeaName,
                                parentProjectName: "",
                            }
                            console.log(param)
                            
                            const requestOptions = {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    "Authorization": "Bearer " + this.accessToken,
                                },
                                body: JSON.stringify(param)
                            };
                            fetch(`${DELEGATE_IDEA_URL}`, requestOptions)
                                .then(response => response.json())
                                .then(data => {
                                    Toast.success('Parent unlinked successfully!', 3000, () => {
                                        this.setState({
                                            clusterModal: !this.state.clusterModal,
                                        })
                                    })
                                    this.updateClusterData();
                                    this.setState({ projectTypeSelectedOption: null, projectIDSelectedOption: null }, () => { })
                                })
                                .catch(error => {
                                    console.log(error)
                                    Toast.fail("Parent unlinked failed", 3000, () => { })
                                });
                        }
                    }
                }

            }
            else {
                Toast.fail("Only idea owner & idea BB can unlink the Parent", 3000, () => { })
            }
        }
        else {
            Toast.fail("Rejected ideas cannot be unlinked / removed.", 3000, () => { })
        }

    }
    updateClusterData = async () => {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    console.log("fetch idea for cluster data", data)
                    this.setState({
                        ideaItem: data.ResultSets.Table1[0],
                        clusterData: data.ClusterData ? data.ClusterData : [],
                    }, () => {
                        if (this.state.clusterData && this.state.clusterData.length > 0) {
                            const targetRecID = this.state.ideaItem.LeanID;
                            const filteredData = this.state.clusterData.filter(item => item.RecAlpha === targetRecID);

                            let getParentAlpa = "";
                            this.state.clusterData.map(item => {
                                if (item.RecAlpha === targetRecID) {
                                    console.log("matched rec apha", item.RecAlpha)
                                    getParentAlpa = item.ParentAlpha;
                                }
                            })
                            console.log("get parent alpha", getParentAlpa)
                            if (getParentAlpa) {
                                this.state.clusterData.map(item => {
                                    if (getParentAlpa === item.RecAlpha) {
                                        const selectedOption = {
                                            value: 0,
                                            label: item.ProjectType
                                        };
                                        this.state.projectTypeSelectedOption = selectedOption;
                                        this.setState({ projectTypeSelectedOption: selectedOption }, () => { })
                                    }
                                })
                            }

                            if (filteredData && filteredData.length > 0 && filteredData !== undefined && filteredData !== null && filteredData !== "") {
                                this.setState({ displayParentAlpha: filteredData[0].ParentAlpha }, () => { })
                                const selectedOption = {
                                    value: 0,
                                    label: filteredData[0].ParentAlpha
                                };
                                this.setState({ projectIDSelectedOption: selectedOption }, () => {
                                    console.log("project type selected option after parent alpha ", this.state.projectIDSelectedOption)
                                    this.setState({ projectIDSelectedOption: selectedOption }, () => {
                                        console.log("abc", this.state.projectTypeSelectedOption)
                                        if (this.state.projectTypeSelectedOption && (this.state.projectTypeSelectedOption.label === null || this.state.projectTypeSelectedOption.label === "")) {
                                            if (this.state.projectIDSelectedOption.label.startsWith("GB")) {
                                                const selectedOptionGB = {
                                                    value: 0,
                                                    label: "GB"
                                                };
                                                this.state.projectTypeSelectedOption = selectedOptionGB;
                                                this.setState({ projectTypeSelectedOption: selectedOptionGB }, () => {
                                                    console.log(this.state.projectTypeSelectedOption)
                                                })
                                            } else {
                                                const selectedOptionBB = {
                                                    value: 0,
                                                    label: "BB"
                                                };
                                                this.state.projectTypeSelectedOption = selectedOptionBB;
                                                this.setState({ projectTypeSelectedOption: selectedOptionBB }, () => {
                                                    console.log(this.state.projectTypeSelectedOption)
                                                })
                                            }
                                        }
                                    })
                                })
                            } else {
                                this.setState({ displayParentAlpha: "" }, () => { })
                            }
                        } else {
                            this.setState({ displayParentAlpha: "" }, () => { })
                        }
                    });
                }
            }
        }
        catch (error) {
            Toast.hide();
            console.log(error)
            Toast.fail("Error while fetching idea. Please try again!", 3000, () => { });
        }
    }
    // clustering function ends here



    // ... DB function starts here....

    // Code change bh TR - sugg by AB
    renderBlackBeltOptions = () => {

        let options = [];
        let result = [];
        this.state.blackbeltList.map((item) => {
            const userRole = JSON.parse(item.pg_Role).pg_role;
            if (userRole === "BB" || userRole === "QA") {
                if (this.state.ownerOHR !== item.pg_ohr) {
                    options.push({ value: item.pg_ohr, label: item.pg_username });
                }
            }
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);
        return result
    }
    // Code change bh TR - sugg by AB


    fetchBlackBeltOptions = async () => {
        try {
            Toast.loading("Fetching Blackbelts. Please wait...", () => { });
            let entityType = "BB";
            let entityName = this.state.ideaItem.RegionManual;
            if (this.state.ideaItem.RegionManual === "Other Regions") {
                entityType = "BBOTHER";
                //DNA table has vertical with space around dash (' - ') whereas User Role table has NO space around dash ('-')
                entityName = this.state.ideaItem.VerticalManual.replace(" - ", "-");
            }
            const param = {
                EntityType: entityType,
                EntityName: entityName,
            };
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.accessToken
                },
                body: JSON.stringify(param)
            };
            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    Toast.hide();
                    console.log(data)
                    this.setState({
                        blackbeltList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
                    });
                }
            }
        } catch (error) {
            Toast.hide();
            Toast.fail('Error occured while getting BlackBelt details. Please try again!', 15000, () => {
                console.log(JSON.stringify(error));
            });
        }
    }
    handleBlackBeltNameChange = (e) => {
        if (parseInt(e.value) === parseInt(this.sessionData.profile.oHRId)) {
            Toast.fail('Mentor user cannot be the same as Idea Owner/Requester. Please select a different Mentor user.', 3000, () => {
                return;
            });
            return;
        }
        let styleStateObj = this.state.selectStyle;
        styleStateObj.blackBeltSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            BlackBeltUserId: e.value,
            BlackBeltUserName: e.label,
            BlackBeltUserEmail: e.value + "@genpact.com",
            blackBeltSelectedOption: e
        }, () => {
        });
    }
    renderSubServiceLineOptions = () => {
        let options = [];
        this.state.subServiceLineList.map((item) => {
            if (this.state.ServiceLineSelectedOption?.label === item.ServiceLineName) {
                options.push({ value: item.SubServiceLineId, label: item.SubServiceLineName });
                return true;
            }
            return true;
        });
        return options;
    }
    handleSubServiceLineChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.subServiceLineSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            subServiceLineId: e.value,

            subServiceLineSelectedOption: {
                label: e.label,
                value: e.value
            }
        });
    }

    handleServiceLineChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.ServiceLineSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            serviceLineId: e.value,

            ServiceLineSelectedOption: {
                label: e.label,
                value: e.value
            },
            subServiceLineSelectedOption: null
        });
        this.renderSubServiceLineOptions();
    }

    renderServiceLineOptions = () => {
        let options = [];
        const uniqueServiceLineList = [...new Map(this.state.serviceLineList?.map(item =>
            [item.ServiceLineName, item])).values()];
        uniqueServiceLineList.map((item) => {
            options.push({ value: item.ServiceLineId, label: item.ServiceLineName });
            return true;
        });
        return options;
    }

    renderMethodologyOptions = () => {
        let options = [];
        this.state.methodologyList && this.state.methodologyList.map((item, ind) => {
            if (this.state.ideaItem.TransformationLeverName === item.TransformationLever && item.RecStatus === true && this.state.ideaItem.AIClassification === item.AIClassification) {
                if (this.state.ideaItem.DigitalProjectType) {
                    if (this.state.ideaItem.DigitalProjectType === item.DigitalProjectType) {
                        options.push({
                            value: item.RecID,
                            label: item.Methodology,
                            sortOrder: item.SOrd || 0
                        })
                    }
                }
                else {
                    options.push({
                        value: item.RecID,
                        label: item.Methodology,
                        sortOrder: item.SOrd || 0
                    })
                }
            }
        })
        options.sort((a, b) => a.sortOrder - b.sortOrder);
        // console.log("options length =>", options.length)
        return options.map(({ value, label }) => ({ value, label }));;
    };

    handleMethodologyChange = (e) => {
        if (e.length <= 10) {
            let styleStateObj = this.state.selectStyle;
            styleStateObj.methodologySelectedOptions = selectStyle(true);
            this.setState({ methodologySelectedOptions: e, selectStyle: styleStateObj, }, () => { });
        } else {
            window.alert("You can add upto 10 tools/methodologies options only.")
            return false;
        }
    };

    // coder section function starts here

    displayCoderSection = () => {
        let displayCoderSection = false;
        this.state.digitalProjectTypeList && this.state.digitalProjectTypeList.map((item) => {
            if (item.IsCoder === 1 || item.IsCoder === "1" || item.IsCoder === true || item.IsCoder === 'true') {
                if (this.state.ideaItem.DigitalProjectType && this.state.ideaItem.DigitalProjectType === item.DPType) {
                    displayCoderSection = true;
                }
            }
        })
        return displayCoderSection
    }

    handleCoderOHRAdd = () => {
        if (this.state.codersLoading) {
            console.log("Please wait, still adding the previous Coder ohr.");
            return;
        }
        const coderOHRs = this.state.coderOHRs || [];
        if (coderOHRs.length >= 10) {
            this.setState({ codersAddButtonDisable: true }, () => { })
            Toast.fail("Max 10 Coder OHRs are allowed.", 3000, () => { })
            return;
        }

        let localOHR = this.state.individualCoderOHR
        if (localOHR.length === 9) {
            let OHRExist = coderOHRs && coderOHRs.some((item) => item.OHR === localOHR)
            if (OHRExist) {
                Toast.info(`Coder's OHR already exist`, 3000)
                this.setState({ individualCoderOHR: "" })
                return
            } else {
                this.setState({
                    codersLoading: true
                }, () => {
                    this.fetchSubmitCoderOHR(localOHR).finally(() => {
                        this.setState({ codersLoading: false })
                    })
                })
            }
        } else {
            Toast.info("Coder OHR must be 9 digits.", 3000)
            return
        }
    }

    handleCoderOHRKeyDown = (e) => {
        if (e.key === "Enter") {
            this.handleCoderOHRAdd()
        }
    }

    handleCoderOhrOnChange = (event) => {
        var numbers = /^[0-9]*$/;
        if (event !== null && event !== undefined) {
            if (event.target.value.match(numbers)) {
                let localCoderOHR = event.target.value.trim();
                this.setState({ individualCoderOHR: localCoderOHR }, () => { })
            }
        }
    }
    handleCoderOHRdelete = (index) => {
        if (window.confirm("Are you sure you want to delete the coder OHR ?")) {
            const { coderOHRs } = this.state;
            const updatedItems = coderOHRs.filter((_, i) => i !== index);
            this.setState({ coderOHRs: updatedItems }, () => {
                if (this.state.coderOHRs.length < 10) {
                    this.setState({ codersAddButtonDisable: false }, () => { })
                }
            });
        }
    }
    fetchSubmitCoderOHR = async (localCoderOHR) => {
        Toast.loading("Fetching Coder's full name, please wait...")
        const param = {
            EntityType: "OHR",
            EntityName: localCoderOHR
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.accessToken,

            },
            body: JSON.stringify(param)
        };
        fetch(GET_METADATA, requestOptions)
            .then(response => response.json())
            .then(data => {
                Toast.hide();
                console.log("data recieved when coder ohr is entered =>", data.DNAUsers.Table1[0].pg_username)
                let requestByName = "";
                if (data.DNAUsers) {
                    if (data.DNAUsers.Table1 && data.DNAUsers.Table1.length > 0) {
                        requestByName = data.DNAUsers.Table1[0].pg_username;
                    }
                }
                if (!requestByName || requestByName === null || requestByName === undefined || requestByName === "") {
                    Toast.fail("We could not find Coder's full name details based on the entered OHR. Please check and re-enter.", 5000, () => { });
                } else {
                    let newUser = {
                        OHRName: requestByName,
                        OHR: localCoderOHR,

                    }
                    this.setState((prevState) => ({
                        coderOHRs: [...(prevState.coderOHRs || []), newUser]
                    }))
                    if (this.state.coderOHRs.length >= 10) {
                        this.setState({ codersAddButtonDisable: true }, () => { })
                    }
                    console.log("coders ohr =>", this.state.coderOHRs)
                }
                Toast.hide();
                this.setState({ individualCoderOHR: "" })
            })
            .catch(error => {
                Toast.hide();
                Toast.fail('Please enter a valid Coder OHR', 5000, () => {
                    console.log(JSON.stringify(error));
                });
                this.setState({ individualCoderOHR: "" })
            });
    };


    // coder section function ends here

    render() {
        

        let convertIdeaID = window.btoa(this.state.ideaItem.IdeaId);
        let IDEA_APPROVED = (this.state.ideaItem.WorkflowStatus === "Approve");
        let IDEA_REJECTED = (this.state.ideaItem.WorkflowStatus === "Reject");
        let IDEA_SEND_BACK = (this.state.ideaItem.WorkflowStatus === "Send Back");

        return (
            <section className="u-clearfix u-section-1" id="sec-0f7f">
                <div className="u-clearfix u-sheet u-sheet-1" style={{ marginBottom: 20 }}>
                    <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
                        <div className="u-container-layout u-container-layout-1">

                            {
                                this.state.ideaItem.ApprovalStatus === 'Pending Documents' && (
                                    <>
                                        <div className="row">
                                            <div className="col-md-8">&nbsp;</div>
                                            <div className="col-md-4">
                                                <div className="cluster_modal_btn_group">
                                                    <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-white u-btn u-btn-round  u-radius-6 u-btn-3 update_parent_btn" onClick={this.showClusterModal}>Update Parent</button>
                                                    <button tabIndex={21} className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6" onClick={this.cancelRequest}>Cancel Request</button>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="text-left mt-4">
                                            {
                                                this.state.cancelRequest
                                                    ?
                                                    <>
                                                        <div className="custom_modal">
                                                            <div className="modal_body" style={{ width: '700px', overflow: 'hidden' }}>
                                                                <div className="row">
                                                                    <div className="col-md-8">
                                                                        <h3 className="modal_title">Cancel Request</h3>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <button type="button" className="close text-right" onClick={(e) => this.setState({ cancelRequest: false })}>&times;</button>
                                                                    </div>
                                                                </div>

                                                                <div className="cancellation_alert_msg">
                                                                    <div className="">
                                                                        <label style={{ color: "red" }}>Note: Once cancelled you cannot have the project reinitiated. You will need to start the project from scratch.</label>
                                                                    </div>
                                                                </div>


                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                                                            <span className="u-text-black form-attribute"><span style={{ color: 'red' }}>*</span>&nbsp;Comments<span style={{ fontWeight: 'normal', fontSize: 12, fontStyle: 'italic', color: 'grey' }}> (max. 500 chars)</span></span>
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-md-2" style={{ display: 'flex', justifyContent: "flex-end", alignItems: "center" }}>
                                                                        <img onClick={(e) => this.toggleTranscriptFunction(14)} src={require("../assets/images/voice.png")} className="w100" alt="" style={{ width: "24px", cursor: "pointer" }} />
                                                                    </div>
                                                                </div>
                                                                <div className="row" style={{ marginTop: 5 }}>
                                                                    <div className="col-md-12">
                                                                        <textarea className="textarea-css form-attribute" rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey', ...this.state.selectStyle.comment }} placeholder="Please provide your comments on reason for cancellation." onChange={this.handleCommentChange} value={this.state.Comments} />
                                                                    </div>
                                                                </div>
                                                                <div className="btn-group" style={{ marginTop: 10 }}>
                                                                    <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={this.submitEvent}>Submit</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }


                                            {/* ....cluster modal starts here.... */}

                                            {
                                                this.state.clusterModal
                                                    ?
                                                    <>
                                                        <div className="cluster_modal_main_block">
                                                            <div className="custom_modal cluster_modal_block">
                                                                <div className="modal_body" style={{ width: '400px' }}>
                                                                    <div className="row">
                                                                        <div className="col-md-11">
                                                                            <h3 className="modal_title text-center" >Update Parent</h3>
                                                                        </div>
                                                                        <div className="col-md-1">
                                                                            <button type="button" className="close text-right" onClick={(e) => this.setState({ clusterModal: false })}>&times;</button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="clustor_modal_fields_block">
                                                                        <div className="clustor_modal_field">
                                                                            <label className="form-attribute"><span style={{ color: "red" }}>*</span> Project Type:</label>
                                                                            {
                                                                                this.state.displayParentAlpha
                                                                                    ?
                                                                                    <>
                                                                                        <input disabled={true} value={this.state.projectTypeSelectedOption ? this.state.projectTypeSelectedOption.label : ""} className="form-input" placeholder="Choose project type" />
                                                                                    </>
                                                                                    :
                                                                                    <Select isSearchable={false} options={projectType} value={this.state.projectTypeSelectedOption} styles={this.state.selectStyle.projectType} placeholder="Choose project type" onChange={this.changeProjectType} />
                                                                            }
                                                                        </div>
                                                                        <div className="clustor_modal_field">
                                                                            <label className="form-attribute"><span style={{ color: "red" }}>*</span> Project ID:</label>
                                                                            {
                                                                                this.state.displayParentAlpha
                                                                                    ?
                                                                                    <>
                                                                                        <input value={this.state.projectIDSelectedOption && this.state.projectIDSelectedOption.label ? this.state.projectIDSelectedOption.label : ""} disabled={true} className="form-input" placeholder="Choose project ID" />
                                                                                    </>
                                                                                    :
                                                                                    <Select isSearchable onInputChange={this.handleClusterProjectInputChange} options={this.displayProjectID()} value={this.state.projectIDSelectedOption} styles={this.state.selectStyle.projectIDSelectedOption} isDisabled={this.state.projectTypeSelectedOption ? false : true} placeholder="Choose project ID" onChange={this.changeProjectID} />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="cluster_modal_btn_group">
                                                                        <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" disabled={this.state.isClusterSaveDisabled ? true : false} onClick={this.saveParentLink}>Save</button>
                                                                        <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6" onClick={this.removeParentFunc} style={{ marginRight: "15px" }}>Remove Parent</button>
                                                                        {
                                                                            this.state.displayParentAlpha
                                                                                ?
                                                                                <>
                                                                                    <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6 show_hierarchy_link_btn"><Link className="show_hierarchy_link_btn_anchor" to={`/showTree?ID=${this.state.ideaItem.IdeaId}`} target='_blank'>Show Hierarchy</Link></button>
                                                                                </>
                                                                                :
                                                                                <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6 show_hierarchy_link_btn">Show Hierarchy</button>
                                                                        }
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>

                                                    </>
                                                    :
                                                    null
                                            }
                                            {/* ....cluster modal ends here.... */}


                                        </div>
                                    </>
                                )
                            }
                            <h4 style={{ textAlign: 'center', color: '#00AECF', fontFamily: 'Arial', fontSize: 22 }}>Update idea : {this.state.ideaItem.IdeaIDAlpha ? this.state.ideaItem.IdeaIDAlpha : this.state.ideaItem.IdeaId} </h4>
                            <div className="u-align-left u-container-style u-expanded-width u-group u-shape-rectangle u-group-2">
                                <div className="u-container-layout u-container-layout-2" style={{ textAlign: 'center' }}>
                                    <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-3">
                                        <div className="u-container-layout u-container-layout-3">
                                            <p className="u-align-left u-text u-text-2" style={{ marginBottom: 15 }}>Owner details</p>
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Owner OHR</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.ideaItem.OwnerOHR} /></div>
                                            </div>
                                            <div style={{ marginBottom: 15 }} />
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Owner Name</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.ideaItem.OwnerName} /></div>
                                            </div>
                                            <div style={{ marginBottom: -10 }} />
                                            <p className="u-align-left u-text u-text-7 u-text-custom-color-3" style={{ fontSize: 11, marginBottom: 10 }}>(If Idea was raised for someone else, their OHR ID is below)</p>
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Request For OHR</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.CreatorOHR} onChange={this.handleCreatorOHRChange} /></div>
                                            </div>
                                            <div style={{ marginBottom: 10 }} />
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Name</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.CreatorName} onChange={this.handleCreatorNameChange} /></div>
                                            </div>
                                            <div style={{ marginBottom: 10 }} />
                                            <div className="row">
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Project ID</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.LeanID} /></div>
                                            </div>
                                            <div style={{ marginBottom: 10 }} />
                                        </div>
                                    </div>

                                    <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 235 }}>&nbsp;</p>

                                    <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-4" style={{ marginTop: -305 }}>
                                        <div className="" style={{ display: "flex", marginTop: "30px" }}>
                                            <div className="u-container-style u-group u-shape-rectangle u-group-5">
                                                <div className="u-container-layout u-container-layout-5">
                                                    <p className="u-align-left u-text u-text-8" style={{ marginBottom: 15 }}>Account Details</p>
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Account&nbsp;Name</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="accounts" name="accounts" placeholder="Choose Account" value={this.state.ideaItem.AccountManual} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Holding&nbsp;Account</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled type="text" value={this.state.ideaItem.HoldingAccount} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Vertical</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="vertical" name="vertical" placeholder="Choose Vertical" value={this.state.ideaItem.VerticalManual} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Industry&nbsp;Vertical</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="subverticallist" name="subverticallist" placeholder="Choose Industry&nbsp;Vertical" value={this.state.ideaItem.SubVerticalName} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />

                                                    {/* units and segments starts here */}
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Segment</label>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="segment" value={this.state.ideaItem.Segment ? this.state.ideaItem.Segment : ""} style={{ fontWeight: 'normal !important' }} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Unit</label>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="unit" value={this.state.ideaItem.Unit ? this.state.ideaItem.Unit : ""} style={{ fontWeight: 'normal !important' }} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    {/* units and segments ends here */}


                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Campaign&nbsp;Name</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="ideationtype" name="ideationtype" placeholder="Choose Idea Type" value={this.state.ideaItem.CampaignName} />
                                                        </div>
                                                        <div className="">
                                                            <div className="campaign_modal_bulb campaign_tool_tip">
                                                                <img
                                                                    src={require("../assets/images/question_mark_2.png")}
                                                                    alt=""
                                                                    className=""
                                                                />
                                                                {
                                                                    this.state.campaignInsight
                                                                        ?
                                                                        <>
                                                                            <span className="my_tooltiptext">{this.state.campaignInsight}</span>
                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />

                                                    {
                                                        this.state.ideaItem.SubCampaignName && (
                                                            <div className="row" style={{ marginBottom: 15 }}>
                                                                <div className="col-md-5" >
                                                                    {
                                                                        this.state.ideaItem.CampaignName === "Gen AI"
                                                                            ?
                                                                            <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Gen AI Theme</label>
                                                                            :
                                                                            <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Sub Campaign</label>
                                                                    }
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input
                                                                        className="form-input"
                                                                        disabled
                                                                        list="subcampaign"
                                                                        name="subcampaign"
                                                                        placeholder="Sub Campaign"
                                                                        value={this.state.ideaItem.SubCampaignName}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )

                                                    }

                                                    {
                                                        this.state.displayProjectTheme && this.state.ideaItem.CampaignName === DATA_BRIDGE_CAMPAIGN && (
                                                            <>
                                                                <div className="row" style={{ marginBottom: 15 }} >
                                                                    <div className="col-md-5">
                                                                        <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Data Bridge Project Theme</label>
                                                                    </div>
                                                                    <div className="col-md-7">
                                                                        <input
                                                                            className="form-input"
                                                                            disabled
                                                                            list="databridgetype"
                                                                            name="databridgetype"
                                                                            placeholder="Choose Data Bridge Project Type"
                                                                            value={this.state.ideaItem.DataBridgeTheme}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div />
                                                            </>
                                                        )
                                                    }

                                                    {
                                                        this.state.displayParentAlpha
                                                            ?
                                                            <>
                                                                <div className="row" style={{ marginBottom: "15px" }}>
                                                                    <div className="col-md-5">
                                                                        <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Parent ID</label>
                                                                    </div>
                                                                    <div className="col-md-7">
                                                                        <input className="form-input" disabled placeholder="Choose Parent ID" value={this.state.displayParentAlpha} />
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                    }


                                                    {
                                                        this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST
                                                            ?
                                                            <>
                                                                <div className="row" style={{ marginBottom: "20px" }}>
                                                                    <div className="col-md-5">
                                                                        <label
                                                                            style={{
                                                                                verticalAlign: "bottom",
                                                                                marginBottom: -5,
                                                                            }}
                                                                        >
                                                                            <i>AI First Sample Ideas</i>
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-7">
                                                                        <div className="ai_first_doc_link ai_first_doc_red_highlight">
                                                                            <a
                                                                                className="ldt-list1"
                                                                                href={AI_DOC_LINK}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                                style={{ textAlign: "left", fontSize: 16, color: "red" }}
                                                                            >Document Link </a>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                {
                                                                    this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                                        ?
                                                                        <>
                                                                            <div style={{ marginBottom: 20 }} />
                                                                            <div className="row d_flex_align_items_center">
                                                                                <div className="col-md-5">
                                                                                    <span className="form-attribute">
                                                                                        AI Recommendation
                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-md-7">
                                                                                    <input
                                                                                        className="form-input"
                                                                                        disabled
                                                                                        name="methodology"
                                                                                        value={this.state.ideaItem.isAI}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null

                                                                }


                                                                {
                                                                    this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                                        ?
                                                                        <>
                                                                            <div style={{ marginBottom: 20 }} />
                                                                            <div className="row">
                                                                                <div className="col-md-5">
                                                                                    <span className="form-attribute">
                                                                                        AI First BRD
                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-md-7">
                                                                                    <div className="ai_first_doc_link">
                                                                                        <textarea className="ai_first_brd_textarea" disabled value={this.state.ideasAI.LinkBRD} ></textarea>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null
                                                                }

                                                            </>
                                                            :
                                                            null
                                                    }



                                                </div>
                                            </div>
                                            <div className="u-container-layout u-container-layout-6">
                                                <div className="row" style={{ marginTop: "10px" }}>
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Country</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled list="country" name="country" placeholder="Choose Country" value={this.state.ideaItem.Country} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Region</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled list="regions" name="regions" placeholder="Choose Region" value={this.state.ideaItem.RegionManual} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Sub-Region</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled list="subregions" name="subregions" placeholder="Choose Sub Region" value={this.state.ideaItem.SubRegion} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Blackbelt&nbsp;Name</label></div>
                                                    <div className="col-md-7">
                                                        <Select tabIndex={9} isSearchable={true} value={this.state.blackBeltSelectedOption} options={this.renderBlackBeltOptions()} styles={this.state.selectStyle.blackBeltSelectedOption} placeholder="Choose Blackbelt" onChange={this.handleBlackBeltNameChange} />

                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>MBB</label></div>
                                                    <div className="col-md-7">
                                                        <input className="form-input" disabled name="blackbelt" placeholder="Choose MBB" title={"OHR ID: " + this.state.ideaItem.MBBOHR} value={this.state.ideaItem.MBBName} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />

                                                {
                                                    this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST &&
                                                        this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                        ?
                                                        <>
                                                            <div style={{ marginBottom: 20 }} />
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <span className="form-attribute">
                                                                        AI First Reason
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <textarea
                                                                        disabled
                                                                        value={this.state.ideasAI.AIReason}
                                                                        placeholder="Please provide value"
                                                                        className="form-input"
                                                                        rows={4}
                                                                        cols={80}
                                                                        style={{
                                                                            width: "100%",
                                                                            border: "1px solid lightgrey",
                                                                            resize: "none"
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: 20 }} />
                                                        </>
                                                        :
                                                        null
                                                }


                                            </div>
                                        </div>
                                    </div>


                                    <div id="idea1" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ paddingTop: "15px", borderTop: '1px solid lightgrey' }}>
                                        <div className="u-container-layout u-container-layout-7">
                                            <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                                <div className="u-container-layout u-container-layout-8">
                                                    <p id="idea1title" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Idea details</p>
                                                    <div className="row">
                                                        <div className="col-md-4"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Service Line</label> </div>
                                                        <div className="col-md-8">
                                                            <Select
                                                                isSearchable={true}
                                                                options={this.renderServiceLineOptions()}
                                                                styles={this.state.selectStyle.ServiceLineSelectedOption}
                                                                placeholder="Choose Service Line"
                                                                value={this.state.ServiceLineSelectedOption}
                                                                onChange={(e) => this.handleServiceLineChange(e)} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-4"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Sub Service Line</label> </div>
                                                        <div className="col-md-8">
                                                            <Select
                                                                isSearchable={true}
                                                                value={this.state.subServiceLineSelectedOption}
                                                                options={this.renderSubServiceLineOptions()}
                                                                styles={this.state.selectStyle.subServiceLineSelectedOption}
                                                                placeholder="Choose Sub Service Line"
                                                                onChange={(e) => this.handleSubServiceLineChange(e)} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                                        <span className="u-text-black form-attribute"> What is the Problem ?</span>&nbsp;</p>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <textarea className="form-input" disabled rows={6} cols={80} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} value={this.state.ideaItem.Problem} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 20 }}>&nbsp;</p>
                                            <div className="u-container-style u-group u-shape-rectangle u-group-9">
                                                <div className="u-container-layout u-container-layout-9" style={{ marginTop: 4 }}>
                                                    <div className="row">
                                                        <div className="col-md-3"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Idea Name</label> </div>
                                                        <div className="col-md-9" style={{ alignItems: 'flex-start' }}><input className="form-input" disabled type="text" value={this.state.ideaItem.IdeaName} placeholder="Eg: Cash flow improvement through process restructuring" /></div>
                                                    </div>
                                                    <div style={{ marginBottom: 65 }} />
                                                    <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: -80 }}>&nbsp;</p>
                                                    <p className="u-align-left u-text u-text-custom-color-4 u-text-25" style={{ width: "177px" }}>
                                                        <span className="u-text-black form-attribute"> How to resolve the problem</span>&nbsp;</p>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <textarea className="form-input" disabled rows={6} cols={80} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} value={this.state.ideaItem.Solution} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{ marginTop: 15 }}>
                                                <div className="col-md-5"><span className="form-attribute">Are you trying to replicate an existing Idea?</span>

                                                </div>
                                                <div className="col-md-4">
                                                    <label className="switch">
                                                        <input disabled type="checkbox" checked={this.state.ideaItem.NewOrReplicatedIdea === null ? false : this.state.ideaItem.NewOrReplicatedIdea} />
                                                        <span className="slider round" />
                                                    </label>
                                                </div>
                                            </div>

                                            {
                                                this.state.ideaItem.NewOrReplicatedIdea && (
                                                    <>
                                                        <div className="col-md-8" style={{ marginBottom: 15, width: "100%" }} />
                                                        <div className="row">
                                                            <div className="col-md-5"><span className="form-attribute">Provide the ID of the executed Idea which you want to replicate?</span>
                                                            </div>
                                                            <div className="col-md-2"><input className="form-input" disabled type="text" value={this.state.ideaItem.ReplicationProjectId} /></div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div style={{ borderBottom: '1px solid lightgrey', marginTop: 40 }} />

                                    <div id="Potential Impact" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                        <div className="u-container-layout u-container-layout-7" style={{ display: "flex", alignItems: "flexStart" }}>
                                            <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                                <div className="u-container-layout u-container-layout-8" style={{ paddingBottom: "0px" }}>
                                                    <p id="Potential Impact" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>More Details</p>
                                                    <div className="row d_flex_align_items_center">
                                                        <div className="col-md-6"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>LDT Lead Name</label> </div>
                                                        <div className="col-md-6">
                                                            <input className="form-input" disabled list="ldtName" name="ldtName" value={this.state.ideaItem.LDTLeadName} title={"OHR ID: " + this.state.ideaItem.LDTId} placeholder="LDT Lead" />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    {
                                                        this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST
                                                            && this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                                            ?
                                                            <>
                                                                <div style={{ marginBottom: 15 }} />
                                                                <div className="row d_flex_align_items_center">
                                                                    <div className="col-md-6">
                                                                        <span className="form-attribute">
                                                                            Is the solution feasible ?
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            className="form-input"
                                                                            disabled
                                                                            value={this.state.IsSolnFeasibleValue}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div style={{ marginBottom: 15 }} />
                                                                <div className="row d_flex_align_items_center">
                                                                    <div className="col-md-6">
                                                                        <span className="form-attribute">
                                                                            Solution Complexity
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            className="form-input"
                                                                            disabled
                                                                            name="methodology"
                                                                            value={
                                                                                this.state.ideasAI.SolnComplexity
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>


                                                                <div style={{ marginBottom: 15 }} />
                                                                <div className="row d_flex_align_items_center">
                                                                    <div className="col-md-6">
                                                                        <span className="form-attribute">
                                                                            Is the Idea replicable
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            className="form-input"
                                                                            disabled
                                                                            value={this.state.isIdeaReplicable}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div style={{ marginBottom: 15 }} />
                                                            </>
                                                            :
                                                            null
                                                    }

                                                    
                                                    <div style={{ marginTop: 10, marginBottom: 14 }} />
                                                    {
                                                        this.state.ideaItem.NewOrReplicatedIdea && (
                                                            <div className="row" style={{ marginBottom: 50 }}>
                                                                <div className="col-md-10">
                                                                    <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Have you verified the replication id and confirm this to be replication project?</label>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <label className="switch">
                                                                        <input disabled type="checkbox" checked={this.state.ideaItem.IsReplicationVerified} />
                                                                        <span className="slider round" />
                                                                    </label>
                                                                </div>
                                                                <div style={{ marginBottom: 15 }} />
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        !this.state.ideaItem.NewOrReplicatedIdea && (
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                    <label style={{ verticalAlign: 'bottom', marginBottom: 17 }}>&nbsp;</label>
                                                                </div>
                                                            </div>
                                                        )
                                                    }


                                                    {
                                                        this.displayCoderSection()
                                                            ?
                                                            <div className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                                                <div className="u-container-layout u-container-layout-7" style={{ paddingTop: "0px" }}>
                                                                    <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Coder Section</p>
                                                                    {/* <div className="row">
                                                                        <div className="col-md-12"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>People Directory Fields
                                                                            <span className="mandatery_asterisk">&nbsp;*</span>
                                                                        </label> </div>
                                                                    </div>
                                                                    <div className="col-md-12" style={{ marginBottom: 15 }} /> */}
                                                                    <div>
                                                                        <div className="row">
                                                                            <div className="col-md-8">
                                                                                <input type="text" onChange={this.handleCoderOhrOnChange} onKeyDown={this.handleCoderOHRKeyDown} value={this.state.individualCoderOHR} placeholder="Enter coder's OHR" className="textarea-css form-attribute hide_numeric_arrows" />
                                                                            </div>
                                                                            <div className="col-md-4">
                                                                                <button onClick={this.handleCoderOHRAdd} disabled={this.state.codersAddButtonDisable} className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3">Add</button>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            this.state.coderOHRs &&
                                                                            <div className="VD_Summary" >
                                                                                <div className="row mt-3">
                                                                                    <div className="col-md-7 col-xs-4 VD_Summary_table_header">
                                                                                        <div className=""><label>Coder Name</label></div>
                                                                                    </div>
                                                                                    <div className="col-md-3 col-xs-4 VD_Summary_table_header">
                                                                                        <div><label>Coder OHR</label></div>
                                                                                    </div>
                                                                                    <div className="col-md-2 col-xs-4 VD_Summary_table_header">
                                                                                        <div style={{ display: 'grid', justifyContent: 'center' }}>
                                                                                            <label>Delete</label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {this.state.coderOHRs && this.state.coderOHRs.map((item, index) => {
                                                                                    return (
                                                                                        <>
                                                                                            <div className="" key={index}>
                                                                                                <div className="row">
                                                                                                    <div className="col-md-7 col-xs-4 VD_Summary_table_row">
                                                                                                        <div style={{ marginTop: '2.5px' }}>
                                                                                                            <label>{item.OHRName}</label>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="col-md-3   col-xs-4 VD_Summary_table_row">
                                                                                                        <div style={{ marginTop: '2.5px' }}>
                                                                                                            <label>{item.OHR}</label>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="col-md-2 col-xs-4 VD_Summary_table_row">
                                                                                                        <div style={{ display: 'grid', justifyContent: 'center', marginTop: '2.5px' }} >
                                                                                                            <button
                                                                                                                title='Delete'
                                                                                                                className="btn btn-danger cursor-pointer btn-sm u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2 p-3"
                                                                                                                style={{ width: '23px', marginTop: '1.5px' }}
                                                                                                                onClick={() => { this.handleCoderOHRdelete(index) }}
                                                                                                            ><i className="fa fa-trash" aria-hidden="true"></i></button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        }

                                                                    </div>
                                                                    <div className="col-md-12" style={{ marginBottom: "15px" }} />
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }







                                                </div>
                                            </div>


                                            <div className="u-container-style u-group u-shape-rectangle">
                                                <div className="u-container-layout u-container-layout-9" style={{ padding: "30px 0px 0px 0px", width: "550px" }}>
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Certification Level</label> </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled list="certificationLevel" value={this.state.ideaItem.CertificationLevelName} name="certificationLevel" placeholder="Certification Level" />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />

                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Transformation Lever</label> </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled value={this.state.ideaItem.TransformationLeverName} list="transformationLever" name="transformationLever" placeholder="Transformation Lever Level" />
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.ideaItem.DigitalProjectType
                                                            ?
                                                            <>
                                                                <div style={{ marginBottom: 15 }} />
                                                                <div className="row">
                                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Digital Project Type</label> </div>
                                                                    <div className="col-md-7">
                                                                        <input className="form-input" disabled value={this.state.ideaItem.DigitalProjectType} title={this.state.ideaItem.DigitalProjectType} list="transformationLever" name="transformationLever" placeholder="Transformation Lever Level" />
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        this.state.ideaItem.AIClassification &&
                                                        <>
                                                            <div style={{ marginTop: 15 }} />

                                                            <div className="row">
                                                                <div className="col-md-5">
                                                                    <span className="form-attribute">
                                                                        AI Classification
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input
                                                                        className="form-input"
                                                                        disabled
                                                                        name="Ai classification"
                                                                        value={this.state.ideaItem.AIClassification}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: 15 }} />
                                                        </>
                                                    }

                                                    {
                                                        this.state.ideaItem.CertificationWorkTypeName !== null && this.state.ideaItem.CertificationWorkTypeName !== ""
                                                            ?
                                                            <>
                                                                <div className="row">
                                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Work Type</label></div>
                                                                    <div className="col-md-7">
                                                                        <input className="form-input" disabled list="certificationWorkType"
                                                                            value={this.state.ideaItem.CertificationWorkTypeName} name="certificationWorkType" />
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                    <div style={{ marginBottom: 15 }} />

                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Tools/Methodology Used</label> </div>
                                                        <div className="col-md-7">
                                                            <Select
                                                                isSearchable={true}
                                                                isMulti={true}
                                                                options={this.renderMethodologyOptions()}
                                                                value={this.state.methodologySelectedOptions}
                                                                styles={this.state.selectStyle.methodologySelectedOptions}
                                                                onChange={this.handleMethodologyChange}
                                                                placeholder="Choose Methodologies"
                                                                title={this.state.methodologySelectedOptions}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    {
                                                        this.state.ideaItem.OtherTools
                                                            ?
                                                            <>
                                                                <div className="row">
                                                                    <div className="col-md-5">
                                                                        <span className="form-attribute">Other tools</span>
                                                                    </div>
                                                                    <div className="col-md-7">
                                                                        <textarea
                                                                            title={this.state.ideaItem.OtherTools}
                                                                            className="form-input"
                                                                            disabled
                                                                            placeholder="Other tools value"
                                                                            name="othertools"
                                                                            value={this.state.ideaItem.OtherTools}
                                                                            style={{ width: "100%", height: "65px", overflowY: "scroll" }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                    }

                                                    <div style={{ marginBottom: 50 }} />

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ borderBottom: '1px solid lightgrey' }} />

                                    <div id="Potential Impact" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                        <div className="u-container-layout u-container-layout-7">
                                            <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Idea Approval details</p>
                                            <div className="row">
                                                <div className="col-md-2"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Approval Status</label> </div>
                                                <div className="col-md-2">
                                                    <input className="form-input" disabled value={IDEA_APPROVED ? APPROVED : (IDEA_REJECTED ? REJECTED : (IDEA_SEND_BACK ? SENT_BACK : PENDING))} list="approvalStatus" name="approvalStatus" placeholder="Choose Status" />
                                                    <datalist id="approvalStatus">
                                                        <option value="Approve" />
                                                        <option value="Send Back" />
                                                        <option value="Rejecte" />
                                                    </datalist>
                                                </div>
                                            </div>
                                            <div className="col-md-12" style={{ marginBottom: 15 }} />

                                            <div className="row" style={{ marginTop: 15 }}>
                                                <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Comments</label></div>
                                                <div className="col-md-2" style={{ marginLeft: 20 }}>
                                                    <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.setState({ commentLog: !this.state.commentLog })}>Comment Log</button>
                                                </div>
                                            </div>
                                            <div className="row" style={{ marginTop: 5 }}>
                                                <div className="col-md-12">
                                                    <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.Comment} />
                                                </div>
                                            </div>
                                            <div className="text-left mt-4">
                                                {
                                                    this.state.commentLog && this.state.reviewComments
                                                        ?
                                                        <>
                                                            <div className="custom_modal">
                                                                <div className="modal_body">
                                                                    <div className="row">
                                                                        <div className="col-md-8">
                                                                            <h3 className="modal_title">Idea Approval Comment Log</h3>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <button type="button" className="close text-right" onClick={(e) => this.setState({ commentLog: false })}>&times;</button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Date & Time</label>
                                                                        </div>
                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>OHR</label>
                                                                        </div>
                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Name</label>
                                                                        </div>
                                                                        <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Role</label>
                                                                        </div>
                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Action</label>
                                                                        </div>
                                                                        <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Comment</label>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        this.state.reviewComments.map((item, index) => {

                                                                            return (
                                                                                <div className="row" key={index}>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{this.formatDateStringWithTime(new Date(item.CreatedDate))}</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterOHR}</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterName}</label>
                                                                                    </div>
                                                                                    <div className="col-md-1 text-center role_over_flow_class" style={{ border: "1px solid lightgrey" }}>
                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole ? item.UpdaterRole : (item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === 'Delegate Action' ? 'BB' : (item.UpdaterOHR === this.state.ideaItem.BlackBeltUserId ? "BB" : (item.UpdaterOHR === this.state.ideaItem.MBBOHR ? "MBB" : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Idea Owner" : "LDT"))))}</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterAction ? item.UpdaterAction : item.Action === 'Idea Reinitiated by Admin' ? 'Idea Reinitiated' : (item.Action === 'Idea Updated by Admin' ? (item.WorkflowStatus !== 'Pending' ? item.WorkflowStatus : 'Idea Updated') : (item.Action === 'Delegate Action' ? 'Delegated' : (item.WorkflowStatus === 'Pending' ? 'Discard Cancellation' : item.WorkflowStatus)))}</label>
                                                                                    </div>
                                                                                    <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.Comment ? item.Comment : '-'}</label>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }

                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ borderBottom: '1px solid lightgrey', marginTop: 15 }} />
                                    {
                                        this.state.ideaItem.ProjectPPTFileName && (
                                            <>
                                                <div className="u-container-layout u-container-layout-7">
                                                    <div className="">
                                                        <div className="u-align-left">
                                                            <p id="Upload" className="u-text u-text-2" style={{ marginBottom: 10 }}>Uploaded documents</p>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <label style={{ verticalAlign: 'bottom' }}>Project Presentation Deck</label>
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                            <button className={this.state.ideaItem.ProjectPPTFileName && this.state.ideaItem.ProjectPPTFileName.length > 50 ? "upload_file_text_overflow" : ""} style={{ backgroundColor: 'transparent', color: '#337ab7', padding: 0 }} onClick={this.showPPTContent}>{this.state.ideaItem.ProjectPPTFileName}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    {
                                                                        this.state.ideaItem.CustomerSignoffFileName
                                                                            ?
                                                                            <>
                                                                                <div className="row">
                                                                                    <div className="col-md-12">
                                                                                        <label style={{ verticalAlign: 'bottom' }}>Client Approval</label> </div>
                                                                                    <div className="col-md-12">
                                                                                        <button className={this.state.ideaItem.CustomerSignoffFileName && this.state.ideaItem.CustomerSignoffFileName.length > 50 ? "upload_file_text_overflow" : ""} style={{ backgroundColor: 'transparent', color: '#337ab7', padding: 0 }} onClick={this.showSignOffContent}>{this.state.ideaItem.CustomerSignoffFileName}</button>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                            :
                                                                            null
                                                                    }

                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: 10 }} />
                                                            <div className="row">
                                                                {
                                                                    this.state.ideaItem.FPnAName || this.state.ideaItem.GOLFileName
                                                                        ?
                                                                        <>
                                                                            <div className="col-md-12">
                                                                                <label style={{ verticalAlign: 'bottom', marginTop: "20px" }}>GOL / FP&A Approval</label>
                                                                            </div>
                                                                            <div className="col-md-12">
                                                                                <button className={this.state.ideaItem.GOLFileName && this.state.ideaItem.GOLFileName.length > 50 ? "upload_file_text_overflow" : ""} style={{ backgroundColor: 'transparent', color: '#337ab7', padding: 0 }} onClick={this.showGOLContent}>{this.state.ideaItem.GOLFileName}</button>
                                                                            </div>
                                                                            <div className="col-md-12">
                                                                                <button className={this.state.ideaItem.FPnAFileName && this.state.ideaItem.FPnAFileName.length > 50 ? "upload_file_text_overflow" : ""} style={{ backgroundColor: 'transparent', color: '#337ab7', padding: 0, marginTop: "10px" }} onClick={this.showFPnAContent}>{this.state.ideaItem.FPnAFileName}</button>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                            <div style={{ marginBottom: 10 }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ borderBottom: '1px solid lightgrey' }} />
                                            </>
                                        )
                                    }
                                    {
                                        (this.state.ideaItem.ApprovalStatus
                                            && this.state.ideaItem.FinalComments !== null
                                        )
                                        && (
                                            <>
                                                <div style={{ borderBottom: '1px solid lightgrey', marginBottom: 10 }} />

                                                <div id="Approval Status" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ borderBottom: '1px solid lightgrey' }}>
                                                    <div className="u-container-layout u-container-layout-7">
                                                        <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Project Approval details</p>
                                                        <div className="row">
                                                            <div className="col-md-2"><span className="form-attribute">Approval Status</span> </div>
                                                            <div className="col-md-2">
                                                                <input className="form-input" disabled name="finalapprovalstatus" value={this.state.ideaItem.ApprovalStatus} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: 15 }}>
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Approval Comments</label></div>
                                                            <div className="col-md-2" style={{ marginLeft: 20 }}>
                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.setState({ finalCommentLog: !this.state.finalCommentLog })}>Comment Log</button>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: 5 }}>
                                                            <div className="col-md-12">
                                                                <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.FinalComments} />
                                                            </div>
                                                        </div>
                                                        <div className="text-left mt-4">
                                                            {
                                                                this.state.finalCommentLog && this.state.finalReviewComments
                                                                    ?
                                                                    <>
                                                                        <div className="custom_modal">
                                                                            <div className="modal_body">
                                                                                <div className="row">
                                                                                    <div className="col-md-8">
                                                                                        <h3 className="modal_title">Lean Approval Comment Log</h3>
                                                                                    </div>
                                                                                    <div className="col-md-4">
                                                                                        <button type="button" className="close text-right" onClick={(e) => this.setState({ finalCommentLog: false })}>&times;</button>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Date & Time</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>OHR</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Name</label>
                                                                                    </div>
                                                                                    <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Role</label>
                                                                                    </div>
                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Action</label>
                                                                                    </div>
                                                                                    <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                        <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Comment</label>
                                                                                    </div>
                                                                                </div>
                                                                                {
                                                                                    this.state.finalReviewComments.map((item, index) => {

                                                                                        return (
                                                                                            <div className="row" key={index}>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{this.formatDateStringWithTime(new Date(item.CreatedDate))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterOHR}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterName}</label>
                                                                                                </div>
                                                                                                <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole ? item.UpdaterRole : (item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === 'Idea was reviewed by MBB' ? "MBB" : (item.Action === 'Idea was reviewed by LDT' ? "LDT" : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Idea Owner" : "BB")))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterAction ? item.UpdaterAction : item.Action === 'Idea Reinitiated by Admin' ? 'Idea Reinitiated' : (item.Action === 'Idea Updated by Admin' ? item.ApprovalStatus : (item.WorkflowStatus === COMPLETE_STATUS || item.WorkflowStatus === 'Approve' || item.WorkflowStatus === 'Approved' || item.ApprovalStatus === AWAITING_QAULITY_CHECK_REVIEW) ? 'Approved' : ((item.WorkflowStatus === 'Rejected' || item.WorkflowStatus === 'Reject') ? "Rejected" : (item.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION ? AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION : (item.WorkflowStatus === 'Pending Documents' ? 'Discard Cancellation' : item.WorkflowStatus === CANCEL ? CANCEL : "Sent Back"))))}</label>
                                                                                                </div>
                                                                                                <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                    <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.Comment !== null ? item.Comment : '-'}</label>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }








                                    {/* ......qc details and comment logs starts here.............. */}

                                    {/* ............... */}
                                    {
                                        this.state.duplicateQCOHR
                                            ?
                                            <>
                                                <div id="Approval Status" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                                    <div className="u-container-layout u-container-layout-7" style={{ borderTop: " 1px solid lightgray", paddingTop: "40px" }}>
                                                        <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Quality Check Details Approval</p>
                                                        <div className="row" style={{ marginTop: 15 }}>
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: "-13px" }}>Approval Comments</label></div>
                                                            <div className="col-md-2" style={{ marginLeft: 20 }}>
                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.setState({ qcCommentLog: true })}>Comment Log</button>
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: 5 }}>
                                                            <div className="col-md-12">
                                                                <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.FinalComments} />
                                                            </div>
                                                        </div>
                                                        <div className="text-left mt-4">
                                                            {
                                                                this.state.qcCommentLog && this.state.qcComments.length > 0
                                                                    ?
                                                                    <>
                                                                        <div className="custom_modal">
                                                                            <div className="modal_body">
                                                                                <div className="row">
                                                                                    <div className="col-md-8">
                                                                                        <h3 className="modal_title">QC Comment Log</h3>
                                                                                    </div>
                                                                                    <div className="col-md-4">
                                                                                        <button type="button" className="close text-right" onClick={(e) => this.setState({ qcCommentLog: false })}>&times;</button>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="qc_responsive_comment_log">
                                                                                    <div className="table table-responsive table-bordered">
                                                                                        <thead className='text-center'>
                                                                                            <tr>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Date & Time</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>OHR</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Name</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Role</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Action</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg" style={{ minWidth: "250px" }}>
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Comment</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthOne">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Is the impact correctly tagged to Genpact or Client ?</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthTwo">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Has the Value Delivery been correctly categorized ?</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthThree">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Has the Value Delivery been computed correctly ?</label>
                                                                                                </th>
                                                                                                <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthFour">
                                                                                                    <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period</label>
                                                                                                </th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                                this.state.qcComments.map((item, index) => {
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{this.formatDateStringWithTime(new Date(item.CreatedDate))}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterOHR}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterName}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole ? item.UpdaterRole : (item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === "Delegate Action" ? 'BB' : (item.UpdaterOHR === this.state.MBBOHR ? 'MBB' : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Idea Owner" : (item.ApprovalStatus === "Pending Documents" && item.WorkflowStatus === "Approved") ? "BB" : (item.ApprovalStatus === "NA" && item.WorkflowStatus === "Pending") ? "BB" : item.UpdaterRole)))}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {/* <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.ApprovalStatus==="Documents Uploaded" ? "Send Back" : ((item.WorkflowStatus==="Rejected" || item.WorkflowStatus==="Reject" || item.ApprovalStatus==="Reject" || item.ApprovalStatus==="Rejected" )? "Rejected ":"Approved")}</label> */}
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterAction ? item.UpdaterAction : item.ApprovalStatus === "Documents Uploaded" ? "Send Back" : ((item.WorkflowStatus === "Rejected" || item.WorkflowStatus === "Reject" || item.ApprovalStatus === "Reject" || item.ApprovalStatus === "Rejected") ? "Rejected " : (item.Action === "Idea was Rework - QC" ? "Rework" : "Approved"))}</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.Comment !== '' ? item.Comment : '-'}</label>
                                                                                                            </td>
                                                                                                            {
                                                                                                                this.state.qcCommentsWithVD && this.state.qcCommentsWithVD.length > 0
                                                                                                                    ?
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            this.state.qcCommentsWithVD.map((pg_item) => {
                                                                                                                                if (Number(pg_item.ProjectTeamID) === item.TrackId) {
                                                                                                                                    return (
                                                                                                                                        <>
                                                                                                                                            <td>
                                                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>

                                                                                                                                                    {JSON.parse(pg_item.AuditDataJSON).pg_isvdimpacttagged ? JSON.parse(pg_item.AuditDataJSON).pg_isvdimpacttagged : "-"}
                                                                                                                                                </label>
                                                                                                                                            </td>
                                                                                                                                            <td>

                                                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>
                                                                                                                                                    {JSON.parse(pg_item.AuditDataJSON).pg_isvdcategorized ? JSON.parse(pg_item.AuditDataJSON).pg_isvdcategorized : "-"}

                                                                                                                                                </label>
                                                                                                                                            </td>
                                                                                                                                            <td>
                                                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>
                                                                                                                                                    {JSON.parse(pg_item.AuditDataJSON).pg_isvdcomputed ? JSON.parse(pg_item.AuditDataJSON).pg_isvdcomputed : "-"}
                                                                                                                                                </label>
                                                                                                                                            </td>
                                                                                                                                            <td>
                                                                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>
                                                                                                                                                    {JSON.parse(pg_item.AuditDataJSON).pg_isvdclientsignoff ? JSON.parse(pg_item.AuditDataJSON).pg_isvdclientsignoff : "-"}
                                                                                                                                                </label>
                                                                                                                                            </td>

                                                                                                                                        </>

                                                                                                                                    )
                                                                                                                                }

                                                                                                                            })
                                                                                                                        }
                                                                                                                    </>
                                                                                                                    :
                                                                                                                    <>
                                                                                                                        <td>
                                                                                                                            <label style={{ lineheight: 2, verticalAlign: "bottom" }}>-</label>
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            <label style={{ lineheight: 2, verticalAlign: "bottom" }}>-</label>
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            <label style={{ lineheight: 2, verticalAlign: "bottom" }}>-</label>
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            <label style={{ lineheight: 2, verticalAlign: "bottom" }}>-</label>
                                                                                                                        </td>
                                                                                                                    </>
                                                                                                            }


                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                            }

                                                                                        </tbody>
                                                                                    </div>
                                                                                </div>


                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="gol_fields_block" style={{ borderBottom: "0px", borderTop: "1px solid lightgray", paddingTop: "10px" }}>
                                                    <p className="u-align-left u-text u-text-2" style={{ margin: "10px 0px 20px" }}>Quality Check Details</p>
                                                    <div className="row u-align-left">
                                                        <div className="col-md-5">
                                                            <div className="row">
                                                                <div className="col-md-9 gol_field_div">
                                                                    <span className="form-attribute">Is the impact correctly tagged to Genpact or Client ?</span>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <input className="form-input disabled_input" disabled value={this.state.ideaItem.IsVDImpactTagged} />
                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: 15 }} />

                                                            <div className="row">
                                                                <div className="col-md-9 gol_field_div">
                                                                    <span className="form-attribute">Has the value delivered been correctly categorized ?</span>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <input className="form-input disabled_input" disabled value={this.state.ideaItem.IsVDCategorized} />
                                                                </div>
                                                            </div>

                                                            <div style={{ marginBottom: 15 }} />

                                                            <div className="row">
                                                                <div className="col-md-5 gol_field_div">
                                                                    <span className="form-attribute">Project Reviewed By</span>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input className="form-input disabled_input" disabled value={this.state.ideaItem.QCName} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2"></div>
                                                        <div className="col-md-5">
                                                            <div className="row">
                                                                <div className="col-md-9 gol_field_div">
                                                                    <span className="form-attribute">Has the value delivered been computed correctly ?</span>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <input disabled value={this.state.ideaItem.IsVDComputed} className="form-input disabled_input" type="text" />
                                                                </div>
                                                            </div>
                                                            <div style={{ marginBottom: 15 }} />

                                                            <div className="row">
                                                                <div className="col-md-9 gol_field_div">
                                                                    <span className="form-attribute">Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period ?</span>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <input disabled className="form-input disabled_input" type="text" value={this.state.ideaItem.IsVDClientSignOff} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            null
                                    }


                                    {/* ......qc details and comment logs ends here.............. */}

                                    {
                                        this.state.ideaItem.CertificationLevelName === "Lean" &&  this.state.businessImpactMasterList
                                            ?
                                            <>
                                                <ValueDelivery 
                                                    IdeaData = {this.state.ideaItem}
                                                    vdForComponent={this.state.vdForComponent}
                                                    BIMasterDataVerseNew={this.state.businessImpactMasterList}
                                                    func={this.pull_data} viewIdea={false}
                                                    vdType={this.handleVDTypeChange}
                                                    IdeaId={this.state.ideaItem.IdeaId}
                                                    fetchMonetizationFileDetails={this.pull_file_data}
                                                    fetchMonetizationFpnaName={this.pull_monetization_fpna_name}
                                                    fetchMonetizationSowID={this.pull_monetization_sowId}
                                                    bbMonetizationTotal={this.pullMonetizedTotal}
                                                    monetizableProject={this.pull_monetizableProject}
                                                    monetizableStatus={this.pull_monetizableStatus}
                                                    fetchFPAOHRforIncreaseInRevenue={this.fetchFPAOHRforIncreaseInRevenue}
                                                    bbMonetizationApproval={false}
                                                    postFpnaValid={false}
                                                    fetchDeletedBIRows={this.remove_bi_data_after_delete}
                                                    fetchMonetizationGOLName={this.pullMonetizationGOLName}
                                                    fetchMonetizationGOLOhr={this.pullMonetizationGOLOhr}
                                                    fetchMonetizationFpnaOhr={this.pull_monetization_fpna_ohr}
                                                    fetchCategoryNotListed={this.pullCategoryNotListed}

                                                    fetchPPTDeck={this.pullPPTDeck}
                                                    fetchClientDocName={this.pullClientDocName}
                                                    fetchClientDocType={this.pullClientDocType}
                                                    fetchClientDocContent={this.pullClientDocContent}
                                                    fetchGolDocName={this.pullgolFileName}
                                                    fetchGolDocType={this.pullgolFileType}
                                                    fetchGolDocContent={this.pullgolContent}
                                                    fetchfpnaDocName={this.pullfpnafileName}
                                                    fetchfpnaDocType={this.pullfpnafileType}
                                                    fetchfpnaDocContent={this.pullfpnafileContent}
                                                    fetchClientName={this.pullClientName}
                                                    fetchClientRole={this.pullClientRole}
                                                    fetchClientSignOffDate={this.pullClientSignOff}
                                                    fetchFpnaName={this.pullFpnaName}
                                                    fetchGolName={this.pullGolName}
                                                    fetchFpnaOhr={this.pullFpnaOhr}
                                                    fetchGolOhr={this.pullGolOhr}
                                                    fetchFileDetails={this.pull_fileDetails}

                                                    

                                                />

                                            </>
                                            :
                                            null
                                    }



                                    <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 0 }}>&nbsp;</p>
                                    <div style={{ borderBottom: '1px solid lightgrey', marginTop: -10, marginBottom: 15 }} />
                                    <div className="btn-group">
                                        <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.mainUpdateIdea(e)}>Submit</button>
                                        <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6" onClick={this.cancelEvent}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            this.state.speechModal
                                ?
                                <UpdatedSpeech modalOpen={true}
                                    onUpdateCancelRequest={this.handleUpdateTranscriptCancelRequest}
                                    modalId={this.state.modalIndex}
                                    closeModalFunction={this.closeModalFunction}
                                    previousText={this.state.Comments}
                                />
                                :
                                null
                        }


                        {this.state.showHrefModal ? (
                            <>
                                <div className="custom_modal href_modal">
                                    <div className="modal_body href_modal_body">
                                        <div className="href_modal_dialog">
                                            <p>
                                                To add a new category please raise a Helpmate
                                                ticket, Click here to View SOP
                                            </p>
                                            <div className="href_modal_body_buttons">
                                                <div className="btn-group href_modal_body_buttons">
                                                    <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3">
                                                        <a
                                                            href="https://genpactonline.sharepoint.com/:b:/r/sites/LeanDigitalTransformation/Documents/KM%20Page%20-%202021/Certification%20Guidelines,%20SOPs%20%26%20Handbooks/Certification%20guidelines,%20SOPs%20%26%20Handbooks/Systems%20%26%20Tools/Helpmate-Data%20Related%20Request/ProGEAR%20Value%20Delivery%20Category%20Addition%20SOP.pdf?csf=1&web=1&e=5kKbFg"
                                                            style={{ color: "#FFF" }}
                                                            target="_blank"
                                                        >
                                                            Click Here
                                                        </a>
                                                    </button>
                                                    <button
                                                        className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6"
                                                        onClick={(e) =>
                                                            this.setState({ showHrefModal: false })
                                                        }
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : null}


                    </div>
                </div>
            </section>
        )




    }
}

export default UpdateIdeaPage;